msgid ""
msgstr ""
"POT-Creation-Date: 2023-11-15 08:45-0400\n"
"MIME-Version: 1.0\n"
"Content-Type: text/plain; charset=utf-8\n"
"Content-Transfer-Encoding: 8bit\n"
"X-Generator: @lingui/cli\n"
"Language: en-US\n"
"Project-Id-Version: \n"
"Report-Msgid-Bugs-To: \n"
"PO-Revision-Date: \n"
"Last-Translator: \n"
"Language-Team: \n"
"Plural-Forms: \n"

msgid "(no formula)"
msgstr "(no formula)"

#. placeholder {0}: 0.5
#. placeholder {0}: breakdown.leaveDays
#. placeholder {0}: item.duration ?? 0
msgid "{0, plural, one {1 day} other {# days}}"
msgstr "{0, plural, one {1 day} other {# days}}"

#. placeholder {0}: selectedEmployees.length
msgid "{0, plural, one {Assign overtime ruleset to employee.} other {Assign overtime rulesets to employees.}}"
msgstr "{0, plural, one {Assign overtime ruleset to employee.} other {Assign overtime rulesets to employees.}}"

#. placeholder {0}: selectedEmployees.length
msgid "{0, plural, one {Assign overtime rulesets} other {Bulk assign overtime rulesets}}"
msgstr "{0, plural, one {Assign overtime rulesets} other {Bulk assign overtime rulesets}}"

#. placeholder {0}: data?.length ?? 0
msgid "{0, plural, one {Delete time clock?} other {Delete time clocks?}}"
msgstr "{0, plural, one {Delete time clock?} other {Delete time clocks?}}"

#. placeholder {0}: selectedEmployees.length
msgid "{0, plural, one {Unassign overtime ruleset from employee.} other {Unassign overtime rulesets from selected employees.}}"
msgstr "{0, plural, one {Unassign overtime ruleset from employee.} other {Unassign overtime rulesets from selected employees.}}"

#. placeholder {0}: selectedEmployees.length
msgid "{0, plural, one {Unassign overtime rulesets} other {Bulk unassign overtime rulesets}}"
msgstr "{0, plural, one {Unassign overtime rulesets} other {Bulk unassign overtime rulesets}}"

#. placeholder {0}: breaks.deleted.length
msgid "{0, plural, zero {# breaks deleted} one {# break deleted} other {# breaks deleted}}"
msgstr "{0, plural, zero {# breaks deleted} one {# break deleted} other {# breaks deleted}}"

#. placeholder {0}: currentBalance.available
#. placeholder {0}: currentBalance.pendingUsed
msgid "{0} days"
msgstr "{0} days"

msgid "{adjustmentTypeLabel} adjustment"
msgstr "{adjustmentTypeLabel} adjustment"

msgid "{balance} days"
msgstr "{balance} days"

msgid "{balanceAfter} days"
msgstr "{balanceAfter} days"

msgid "{balanceAfterApproval} days"
msgstr "{balanceAfterApproval} days"

msgid "{balanceBeforeLabel} → {balanceAfterLabel}"
msgstr "{balanceBeforeLabel} → {balanceAfterLabel}"

msgid "{breakCount, plural, one {Delete break?} other {Delete breaks?}}"
msgstr "{breakCount, plural, one {Delete break?} other {Delete breaks?}}"

msgid "{conditionType}: {timeTypeName} after {thresholdDuration}"
msgstr "{conditionType}: {timeTypeName} after {thresholdDuration}"

msgid "{count, plural, one {Delete crew member} other {Delete # crew members}}"
msgstr "{count, plural, one {Delete crew member} other {Delete # crew members}}"

msgid "{count, plural, one {Delete crew timesheet} other {Delete # crew timesheets}}"
msgstr "{count, plural, one {Delete crew timesheet} other {Delete # crew timesheets}}"

msgid "{count, plural, one {Delete timesheet} other {Delete # timesheets}}"
msgstr "{count, plural, one {Delete timesheet} other {Delete # timesheets}}"

msgid "{count, plural, one {The following crew member will be permanently deleted.} other {The following crew members will be permanently deleted.} =0 {You selected zero crew members.}}"
msgstr "{count, plural, one {The following crew member will be permanently deleted.} other {The following crew members will be permanently deleted.} =0 {You selected zero crew members.}}"

msgid "{count, plural, one {The following crew timesheet will be permanently deleted.} other {The following crew timesheets will be permanently deleted.} =0 {You selected zero crew timesheets.}}"
msgstr "{count, plural, one {The following crew timesheet will be permanently deleted.} other {The following crew timesheets will be permanently deleted.} =0 {You selected zero crew timesheets.}}"

msgid "{count, plural, one {The following timesheet will be permanently deleted.} other {The following timesheets will be permanently deleted.} =0 {You selected zero timesheets.}}"
msgstr "{count, plural, one {The following timesheet will be permanently deleted.} other {The following timesheets will be permanently deleted.} =0 {You selected zero timesheets.}}"

msgid "{duration, plural, zero {Duration: # days} one {Duration: 1 day} other {Duration: # days}}"
msgstr "{duration, plural, zero {Duration: # days} one {Duration: 1 day} other {Duration: # days}}"

msgid "{employeeName} — Leave"
msgstr "{employeeName} — Leave"

msgid "{feet} ft"
msgstr "{feet} ft"

msgid "{holidaysLength, plural, zero {There are no holidays within the selected time range.} one {There is a holiday within the selected time range. Please adjust the time.} other {There are holidays within the selected time range. Please adjust the time.}}"
msgstr "{holidaysLength, plural, zero {There are no holidays within the selected time range.} one {There is a holiday within the selected time range. Please adjust the time.} other {There are holidays within the selected time range. Please adjust the time.}}"

msgid "{inches} in"
msgstr "{inches} in"

msgid "{kilometers} km"
msgstr "{kilometers} km"

msgid "{leaveType} — {statusLabel}"
msgstr "{leaveType} — {statusLabel}"

msgid "{meter} m"
msgstr "{meter} m"

msgid "{miles} mi"
msgstr "{miles} mi"

msgid "{numberBalance} days"
msgstr "{numberBalance} days"

msgid "{numberOfClocks, plural, one {Time clock deleted} other {# time clocks deleted}}"
msgstr "{numberOfClocks, plural, one {Time clock deleted} other {# time clocks deleted}}"

msgid "{option} days"
msgstr "{option} days"

msgid "{pendingDays} upcoming"
msgstr "{pendingDays} upcoming"

msgid "{percent} uploaded"
msgstr "{percent} uploaded"

msgid "{predefinedRulesetName} <0>(deprecated)</0>"
msgstr "{predefinedRulesetName} <0>(deprecated)</0>"

msgid "{requestedDays} days"
msgstr "{requestedDays} days"

msgid "{requestedDays} requested"
msgstr "{requestedDays} requested"

msgid "{selectedCount, plural, one {Submit # timesheet} other {Submit # timesheets}}"
msgstr "{selectedCount, plural, one {Submit # timesheet} other {Submit # timesheets}}"

msgid "{startDate} → {endDate}"
msgstr "{startDate} → {endDate}"

msgid "{startLabel} → {endLabel}"
msgstr "{startLabel} → {endLabel}"

msgid "{threshold} days"
msgstr "{threshold} days"

msgid "{threshold}h"
msgstr "{threshold}h"

msgid "{threshold}h {minutes}m"
msgstr "{threshold}h {minutes}m"

msgid "{timesheetDescription} Copy"
msgstr "{timesheetDescription} Copy"

msgid "{timeTypeTerminology} is required"
msgstr "{timeTypeTerminology} is required"

msgid "{timeTypeTerminology} must be enabled to exclude specific values from hourly percent accrual calculations."
msgstr "{timeTypeTerminology} must be enabled to exclude specific values from hourly percent accrual calculations."

msgid "{usedSince} days since {usedSinceLabel}"
msgstr "{usedSince} days since {usedSinceLabel}"

msgid "{utilizedDays} days approved"
msgstr "{utilizedDays} days approved"

msgid "{value} minutes"
msgstr "{value} minutes"

msgid "<0>Data you provide and app function:</0> The Time Assistant app collects and transmits to the Sage Intelligent Time service the following information: activity data from the time you give consent onward like operating system and device type; information related to your interaction with the system like how many times you interacted with your computer since your computer was last idle (we do not record keystrokes); and application use data like active application name, timestamp of when you switched active application windows, and URLs of websites in open browser applications."
msgstr "<0>Data you provide and app function:</0> The Time Assistant app collects and transmits to the Sage Intelligent Time service the following information: activity data from the time you give consent onward like operating system and device type; information related to your interaction with the system like how many times you interacted with your computer since your computer was last idle (we do not record keystrokes); and application use data like active application name, timestamp of when you switched active application windows, and URLs of websites in open browser applications."

msgid "<0>Data you provide:</0> Calendar information from the time you give consent onward and the week prior to consent date, including content like event description and attachment names, header information like sender, recipients and start and end time, and metadata like created and updated dates."
msgstr "<0>Data you provide:</0> Calendar information from the time you give consent onward and the week prior to consent date, including content like event description and attachment names, header information like sender, recipients and start and end time, and metadata like created and updated dates."

msgid "<0>Data you provide:</0> Email information from the time you give consent onward, including header information like subject, sender, recipients and sent time stamp, and metadata like created and updated dates."
msgstr "<0>Data you provide:</0> Email information from the time you give consent onward, including header information like subject, sender, recipients and sent time stamp, and metadata like created and updated dates."

msgid "<0>Disclosed to:</0> The Sage Group plc or a subsidiary (the controller, as to you; the processor, as to your employer)."
msgstr "<0>Disclosed to:</0> The Sage Group plc or a subsidiary (the controller, as to you; the processor, as to your employer)."

msgid "<0>Disclosed to:</0> The Sage Group plc or a subsidiary (the processor of data for timesheets; the controller of algorithm training data) is seeking your consent and receives the data from the Time Assistant."
msgstr "<0>Disclosed to:</0> The Sage Group plc or a subsidiary (the processor of data for timesheets; the controller of algorithm training data) is seeking your consent and receives the data from the Time Assistant."

msgid "<0>How to opt out:</0> Click \"disconnect\" next to the account in the time sources page."
msgstr "<0>How to opt out:</0> Click \"disconnect\" next to the account in the time sources page."

msgid "<0>How to opt out:</0> If you choose not to install, or disconnect and uninstall as described in the <1>documentation</1>."
msgstr "<0>How to opt out:</0> If you choose not to install, or disconnect and uninstall as described in the <1>documentation</1>."

msgid "<0>IMPORTANT:</0> These advanced preferences require assistance from professional services or support. If you hired a service provider to assist with implementing Sage Intelligent Time, they will contact you directly regarding next steps. We strongly recommend that you wait to complete these preferences until your service provider engages with you to help. This will ensure a smooth implementation or deactivation of SIT. If you have questions or need further assistance, please contact your Sage Intacct Account Manager directly."
msgstr "<0>IMPORTANT:</0> These advanced preferences require assistance from professional services or support. If you hired a service provider to assist with implementing Sage Intelligent Time, they will contact you directly regarding next steps. We strongly recommend that you wait to complete these preferences until your service provider engages with you to help. This will ensure a smooth implementation or deactivation of SIT. If you have questions or need further assistance, please contact your Sage Intacct Account Manager directly."

msgid "<0>MacOS</0> or <1>Windows.</1>"
msgstr "<0>MacOS</0> or <1>Windows.</1>"

msgid "<0>Name:</0> {rulesetName}"
msgstr "<0>Name:</0> {rulesetName}"

msgid "<0>Operators:</0> +, -, *, / for arithmetic. Use <1>condition ? value1 : value2</1> for conditionals. Example: <2>employeeTenureYears >= 5 ? 25 : 15</2>"
msgstr "<0>Operators:</0> +, -, *, / for arithmetic. Use <1>condition ? value1 : value2</1> for conditionals. Example: <2>employeeTenureYears >= 5 ? 25 : 15</2>"

msgid "<0>Overtime Tracking</0><1/>This shows calculated overtime compared to what's applied in timesheet entries.<2/><3/><4>Table Columns:</4><5/>• <6>Applied hours</6> - Hours assigned to this overtime type<7/>• <8>Variance</8> - Difference between calculated and applied overtime<9/>• <10>Status</10> - Missing hours (red), Excess hours (orange), or Correct (green)<11/><12/>Use \"Resolve missing overtime\" to auto-fix discrepancies, or adjust timesheet entries manually."
msgstr "<0>Overtime Tracking</0><1/>This shows calculated overtime compared to what's applied in timesheet entries.<2/><3/><4>Table Columns:</4><5/>• <6>Applied hours</6> - Hours assigned to this overtime type<7/>• <8>Variance</8> - Difference between calculated and applied overtime<9/>• <10>Status</10> - Missing hours (red), Excess hours (orange), or Correct (green)<11/><12/>Use \"Resolve missing overtime\" to auto-fix discrepancies, or adjust timesheet entries manually."

msgid "<0>Retained until:</0> When connecting your account, you will be prompted to choose how long we retain your data. You can change this setting at any time."
msgstr "<0>Retained until:</0> When connecting your account, you will be prompted to choose how long we retain your data. You can change this setting at any time."

msgid "<0>Used for:</0> To help you create timesheet entries and to train algorithms that automate creation of timesheet entry descriptions."
msgstr "<0>Used for:</0> To help you create timesheet entries and to train algorithms that automate creation of timesheet entry descriptions."

msgid "3rd party licenses"
msgstr "3rd party licenses"

msgid "A break action is already in progress. Please wait for it to finish, then try again."
msgstr "A break action is already in progress. Please wait for it to finish, then try again."

msgid "A new row"
msgstr "A new row"

msgid "A time clock action is already in progress. Please wait for it to finish, then try again."
msgstr "A time clock action is already in progress. Please wait for it to finish, then try again."

msgid "About predefined rulesets"
msgstr "About predefined rulesets"

msgid "Account"
msgstr "Account"

msgid "Accrual method"
msgstr "Accrual method"

msgid "Accrue a fixed number of days"
msgstr "Accrue a fixed number of days"

msgid "Accrue at the start of each year"
msgstr "Accrue at the start of each year"

msgid "Accrue days based on months with company"
msgstr "Accrue days based on months with company"

msgid "Accrue every day"
msgstr "Accrue every day"

msgid "Accrue every Sunday"
msgstr "Accrue every Sunday"

msgid "Accrue more days as employees gain tenure"
msgstr "Accrue more days as employees gain tenure"

msgid "Accrue on employee's work anniversary"
msgstr "Accrue on employee's work anniversary"

msgid "Accrue on the 1st of each month"
msgstr "Accrue on the 1st of each month"

msgid "Accrue with carry-over cap consideration"
msgstr "Accrue with carry-over cap consideration"

msgid "Action"
msgstr "Action"

msgid "Actions"
msgstr "Actions"

msgid "Activate"
msgstr "Activate"

msgid "Active"
msgstr "Active"

msgid "Active overtime ruleset"
msgstr "Active overtime ruleset"

msgid "Active time clock"
msgstr "Active time clock"

msgid "Activities"
msgstr "Activities"

msgid "Activities generated successfully"
msgstr "Activities generated successfully"

msgid "Activity assignment is not supported in crew timesheets."
msgstr "Activity assignment is not supported in crew timesheets."

msgid "Activity card associated with {assignedEntryStatus} entry."
msgstr "Activity card associated with {assignedEntryStatus} entry."

msgid "Activity card is locked."
msgstr "Activity card is locked."

msgid "Activity card marked as not attended."
msgstr "Activity card marked as not attended."

msgid "Activity card marked as trash."
msgstr "Activity card marked as trash."

msgid "Activity cards"
msgstr "Activity cards"

msgid "Activity tabs"
msgstr "Activity tabs"

msgid "Add"
msgstr "Add"

#. placeholder {0}: item.name
msgid "Add {0}"
msgstr "Add {0}"

msgid "Add a crew member to begin entering time."
msgstr "Add a crew member to begin entering time."

msgid "Add a crew timesheet and it will show up here."
msgstr "Add a crew timesheet and it will show up here."

msgid "Add a timesheet and it will show up here."
msgstr "Add a timesheet and it will show up here."

msgid "Add at least one tenure tier"
msgstr "Add at least one tenure tier"

msgid "Add crew member"
msgstr "Add crew member"

msgid "Add notes"
msgstr "Add notes"

msgid "Add notes and dimensions"
msgstr "Add notes and dimensions"

msgid "Add or deduct days from an employee's leave balance. Use positive values to add and negative values to deduct."
msgstr "Add or deduct days from an employee's leave balance. Use positive values to add and negative values to deduct."

msgid "Add row"
msgstr "Add row"

msgid "Add rule"
msgstr "Add rule"

msgid "Add rule group"
msgstr "Add rule group"

msgid "Add rule to group"
msgstr "Add rule to group"

msgid "Add tier"
msgstr "Add tier"

msgid "Add work location"
msgstr "Add work location"

msgid "Additional days per month"
msgstr "Additional days per month"

msgid "Additional days per year"
msgstr "Additional days per year"

msgid "Adjust employee leave balance"
msgstr "Adjust employee leave balance"

msgid "Adjust leave balance"
msgstr "Adjust leave balance"

msgid "Advanced"
msgstr "Advanced"

msgid "Advanced preferences"
msgstr "Advanced preferences"

msgid "After"
msgstr "After"

msgid "After approval"
msgstr "After approval"

msgid "After declining"
msgstr "After declining"

msgid "After you've connected time sources, Sage Intelligent Time learns your work activities and automatically pre-populates your timesheet with AI-powered predictions. You maintain control over your data. Only you can see the data gathered."
msgstr "After you've connected time sources, Sage Intelligent Time learns your work activities and automatically pre-populates your timesheet with AI-powered predictions. You maintain control over your data. Only you can see the data gathered."

msgid "All overtime hours are correctly applied."
msgstr "All overtime hours are correctly applied."

msgid "Allocation"
msgstr "Allocation"

msgid "Allocation details"
msgstr "Allocation details"

msgid "Allocation preview"
msgstr "Allocation preview"

msgid "Allocations"
msgstr "Allocations"

msgid "AM"
msgstr "AM"

msgid "Amount"
msgstr "Amount"

msgid "Amount (days)"
msgstr "Amount (days)"

msgid "Amount cannot be zero"
msgstr "Amount cannot be zero"

msgid "An easily identifiable name for the ruleset"
msgstr "An easily identifiable name for the ruleset"

msgid "An error has occurred while uploading"
msgstr "An error has occurred while uploading"

msgid "An overtime rule in the past may require resubmitting existing timesheets to properly apply overtime"
msgstr "An overtime rule in the past may require resubmitting existing timesheets to properly apply overtime"

msgid "Anniversary"
msgstr "Anniversary"

msgid "Annual amount (days)"
msgstr "Annual amount (days)"

msgid "API"
msgstr "API"

msgid "Applied hours"
msgstr "Applied hours"

msgid "Applied on the employee's work anniversary before the new anniversary accrual is added."
msgstr "Applied on the employee's work anniversary before the new anniversary accrual is added."

msgid "Apply to all employees"
msgstr "Apply to all employees"

msgid "Applying..."
msgstr "Applying..."

msgid "Approval history"
msgstr "Approval history"

msgid "Approval stage"
msgstr "Approval stage"

msgid "Approval state"
msgstr "Approval state"

msgid "Approval type"
msgstr "Approval type"

msgid "Approval/declined by "
msgstr "Approval/declined by "

msgid "Approvals | Sage Intelligent Time"
msgstr "Approvals | Sage Intelligent Time"

msgid "approve"
msgstr "approve"

msgid "Approve"
msgstr "Approve"

msgid "Approve anyway"
msgstr "Approve anyway"

msgid "Approve leave requests"
msgstr "Approve leave requests"

msgid "Approve lines"
msgstr "Approve lines"

msgid "Approve request"
msgstr "Approve request"

msgid "Approve time entries"
msgstr "Approve time entries"

msgid "Approve timesheet"
msgstr "Approve timesheet"

msgid "Approve timesheets"
msgstr "Approve timesheets"

msgid "Approved"
msgstr "Approved"

msgid "Approved by: {approvedByName}."
msgstr "Approved by: {approvedByName}."

msgid "Approved by: {approvedByName}. Notes: {comments}"
msgstr "Approved by: {approvedByName}. Notes: {comments}"

msgid "Approved by: {approverName}."
msgstr "Approved by: {approverName}."

msgid "Approved upcoming leave:"
msgstr "Approved upcoming leave:"

msgid "Approved: {approvedDate}"
msgstr "Approved: {approvedDate}"

msgid "Approved/declined by"
msgstr "Approved/declined by"

msgid "Approver"
msgstr "Approver"

msgid "Approving entries, we'll notify you when we finish."
msgstr "Approving entries, we'll notify you when we finish."

msgid "Approving timesheets, we'll notify you when we finish."
msgstr "Approving timesheets, we'll notify you when we finish."

msgid "Approving..."
msgstr "Approving..."

msgid "Are you sure you want to clock out of the active time clock and start this one?"
msgstr "Are you sure you want to clock out of the active time clock and start this one?"

msgid "Are you sure you want to delete {deleteName}?"
msgstr "Are you sure you want to delete {deleteName}?"

msgid "Are you sure you want to delete this account?"
msgstr "Are you sure you want to delete this account?"

msgid "Are you sure you want to delete this rate card?"
msgstr "Are you sure you want to delete this rate card?"

msgid "Are you sure you want to leave this page?"
msgstr "Are you sure you want to leave this page?"

msgid "Are you sure you would like to delete the timesheet row?"
msgstr "Are you sure you would like to delete the timesheet row?"

msgid "Assign"
msgstr "Assign"

msgid "Assign activity card"
msgstr "Assign activity card"

msgid "Assign activity card as"
msgstr "Assign activity card as"

msgid "Assign employees to this location to restrict user time clocks"
msgstr "Assign employees to this location to restrict user time clocks"

msgid "Assign employees to this ruleset to apply overtime rules"
msgstr "Assign employees to this ruleset to apply overtime rules"

msgid "Assign into row"
msgstr "Assign into row"

msgid "Assign ruleset"
msgstr "Assign ruleset"

msgid "Assign to a new row"
msgstr "Assign to a new row"

msgid "Assigned"
msgstr "Assigned"

msgid "Assigning..."
msgstr "Assigning..."

msgid "Associated accounts"
msgstr "Associated accounts"

msgid "At least one group or one rule is required"
msgstr "At least one group or one rule is required"

msgid "At least two rules are required in a group"
msgstr "At least two rules are required in a group"

msgid "Attachments"
msgstr "Attachments"

msgid "Auto-assigned based on your reporting structure"
msgstr "Auto-assigned based on your reporting structure"

msgid "Available (name, start date)"
msgstr "Available (name, start date)"

msgid "Available variables"
msgstr "Available variables"

msgid "Away"
msgstr "Away"

msgid "Back"
msgstr "Back"

msgid "Balance"
msgstr "Balance"

msgid "Balance adjustments"
msgstr "Balance adjustments"

msgid "Balance after approval:"
msgstr "Balance after approval:"

msgid "Balance preview"
msgstr "Balance preview"

msgid "Balance-Adjusted"
msgstr "Balance-Adjusted"

msgid "Base days"
msgstr "Base days"

msgid "Based on Months of Service"
msgstr "Based on Months of Service"

msgid "Based on Years of Service"
msgstr "Based on Years of Service"

msgid "Before"
msgstr "Before"

msgid "Begin date"
msgstr "Begin date"

msgid "Beta"
msgstr "Beta"

msgid "bi-weekly"
msgstr "bi-weekly"

msgid "Bill more time and spend less time on time entry"
msgstr "Bill more time and spend less time on time entry"

msgid "Billable"
msgstr "Billable"

msgid "Billable hours"
msgstr "Billable hours"

msgid "Bonus days"
msgstr "Bonus days"

msgid "Break begin"
msgstr "Break begin"

msgid "Break deleted"
msgstr "Break deleted"

msgid "Break end"
msgstr "Break end"

msgid "Break end time must be after break begin time"
msgstr "Break end time must be after break begin time"

msgid "Break end time must be before clock out time"
msgstr "Break end time must be before clock out time"

msgid "Break end time must be in the past"
msgstr "Break end time must be in the past"

msgid "Break start time must be after clock in time"
msgstr "Break start time must be after clock in time"

msgid "Break start time must be in the past"
msgstr "Break start time must be in the past"

msgid "Break time"
msgstr "Break time"

msgid "Breaks"
msgstr "Breaks"

msgid "Breaks must not overlap"
msgstr "Breaks must not overlap"

msgid "Browser location permission was denied during clock-in."
msgstr "Browser location permission was denied during clock-in."

msgid "Browser location was unavailable or timed out during clock-in."
msgstr "Browser location was unavailable or timed out during clock-in."

msgid "Browser requirements"
msgstr "Browser requirements"

msgid "By clicking below to connect your calendar application account(s) means that you agree to our use of your calendar data as stated below and detailed in the "
msgstr "By clicking below to connect your calendar application account(s) means that you agree to our use of your calendar data as stated below and detailed in the "

msgid "By clicking below to connect your calendar application account(s) means that you agree to our use of your calendar data as stated below and detailed in the <0>Privacy policy</0>"
msgstr "By clicking below to connect your calendar application account(s) means that you agree to our use of your calendar data as stated below and detailed in the <0>Privacy policy</0>"

msgid "By clicking below to connect your email account(s) means that you agree to our use of your email data as stated below and detailed in the "
msgstr "By clicking below to connect your email account(s) means that you agree to our use of your email data as stated below and detailed in the "

msgid "Calendar"
msgstr "Calendar"

msgid "Calendar days selected:"
msgstr "Calendar days selected:"

msgid "Calendar days:"
msgstr "Calendar days:"

msgid "Calendar event"
msgstr "Calendar event"

msgid "Calendar legend"
msgstr "Calendar legend"

msgid "Calendar not connected."
msgstr "Calendar not connected."

msgid "Calendar synced successfully"
msgstr "Calendar synced successfully"

msgid "Cancel"
msgstr "Cancel"

msgid "Cancel request"
msgstr "Cancel request"

msgid "Cancel split"
msgstr "Cancel split"

msgid "Cancel upload"
msgstr "Cancel upload"

msgid "Canceled"
msgstr "Canceled"

msgid "Cancelling..."
msgstr "Cancelling..."

msgid "Cannot delete because employees are assigned to this ruleset"
msgstr "Cannot delete because employees are assigned to this ruleset"

msgid "Carry-over cap (days)"
msgstr "Carry-over cap (days)"

msgid "Change Employee"
msgstr "Change Employee"

msgid "Changes to the attachments were saved"
msgstr "Changes to the attachments were saved"

msgid "Changing the employee will remove all rows and data. Do you want to proceed?"
msgstr "Changing the employee will remove all rows and data. Do you want to proceed?"

msgid "Check the checkbox below to also delete the generated activity cards associated with this time source. If you choose not to delete them, you can request at a later date that they be deleted by contacting customer support."
msgstr "Check the checkbox below to also delete the generated activity cards associated with this time source. If you choose not to delete them, you can request at a later date that they be deleted by contacting customer support."

msgid "Checking location..."
msgstr "Checking location..."

msgid "Choose a formula template"
msgstr "Choose a formula template"

msgid "Choose a predefined template..."
msgstr "Choose a predefined template..."

msgid "Choose where to assign"
msgstr "Choose where to assign"

msgid "Class"
msgstr "Class"

msgid "Clear"
msgstr "Clear"

msgid "Clicking “Download Time Assistant” means that you agree (1) to install the Time Assistant app and any future updates and upgrades by Sage and (2) to opt into our collection and use of your personal data as stated below and detailed in the <0>Privacy policy</0>."
msgstr "Clicking “Download Time Assistant” means that you agree (1) to install the Time Assistant app and any future updates and upgrades by Sage and (2) to opt into our collection and use of your personal data as stated below and detailed in the <0>Privacy policy</0>."

msgid "Clicking below to connect your email account(s) means that you agree to our use of your email data as stated below and detailed in the <0>Privacy policy</0>"
msgstr "Clicking below to connect your email account(s) means that you agree to our use of your email data as stated below and detailed in the <0>Privacy policy</0>"

msgid "Client"
msgstr "Client"

msgid "Clock in"
msgstr "Clock in"

msgid "Clock in time"
msgstr "Clock in time"

msgid "Clock in time is required"
msgstr "Clock in time is required"

msgid "Clock in time must be in the past"
msgstr "Clock in time must be in the past"

msgid "Clock out"
msgstr "Clock out"

msgid "Clock out time"
msgstr "Clock out time"

msgid "Clock out time must be after clock in time"
msgstr "Clock out time must be after clock in time"

msgid "Clock out time must be in the past"
msgstr "Clock out time must be in the past"

msgid "Clock-in location violation"
msgstr "Clock-in location violation"

msgid "Clock-in time"
msgstr "Clock-in time"

msgid "Clock-ins are not permitted on holidays"
msgstr "Clock-ins are not permitted on holidays"

msgid "Clocked in from the web"
msgstr "Clocked in from the web"

msgid "Close"
msgstr "Close"

msgid "Collapse"
msgstr "Collapse"

msgid "Collapse all"
msgstr "Collapse all"

msgid "Collapse crew member rows"
msgstr "Collapse crew member rows"

msgid "Comment"
msgstr "Comment"

msgid "Comments"
msgstr "Comments"

msgid "Companies managed at the entity level cannot create timesheets at the top level."
msgstr "Companies managed at the entity level cannot create timesheets at the top level."

msgid "Company ID not found"
msgstr "Company ID not found"

msgid "Complete all required time clock fields before clocking out."
msgstr "Complete all required time clock fields before clocking out."

msgid "Complete all required time clock fields before splitting this time clock."
msgstr "Complete all required time clock fields before splitting this time clock."

msgid "Completed by"
msgstr "Completed by"

msgid "Computer activity"
msgstr "Computer activity"

msgid "Condition type"
msgstr "Condition type"

msgid "Condition type is required"
msgstr "Condition type is required"

msgid "Configure annual accrual amounts by years of service. The highest matching tier applies."
msgstr "Configure annual accrual amounts by years of service. The highest matching tier applies."

msgid "Configure leave accrual rules and assign them to employee groups."
msgstr "Configure leave accrual rules and assign them to employee groups."

msgid "Configure leave accrual rules and assign to an employee group."
msgstr "Configure leave accrual rules and assign to an employee group."

msgid "Configure overtime rules and settings for employee time calculations."
msgstr "Configure overtime rules and settings for employee time calculations."

msgid "Configure parameters"
msgstr "Configure parameters"

msgid "Confirm"
msgstr "Confirm"

msgid "Confirm clock out and restart"
msgstr "Confirm clock out and restart"

msgid "Connect"
msgstr "Connect"

msgid "Connect account"
msgstr "Connect account"

msgid "Connect another"
msgstr "Connect another"

msgid "Connect another {source} to auto-generate time entries."
msgstr "Connect another {source} to auto-generate time entries."

msgid "Connect another calendar"
msgstr "Connect another calendar"

msgid "Connect another email"
msgstr "Connect another email"

msgid "Connect any of the time sources listed to automate and enhance your timesheets with AI."
msgstr "Connect any of the time sources listed to automate and enhance your timesheets with AI."

msgid "Connected time sources"
msgstr "Connected time sources"

msgid "Connection"
msgstr "Connection"

msgid "Connection initiated but no emails found. Please contact support."
msgstr "Connection initiated but no emails found. Please contact support."

msgid "Connection initiated but no events found. Please contact support."
msgstr "Connection initiated but no events found. Please contact support."

msgid "Connection initiated. However, no emails have been retrieved yet. Please contact support."
msgstr "Connection initiated. However, no emails have been retrieved yet. Please contact support."

msgid "Consecutive day"
msgstr "Consecutive day"

msgid "Consecutive hour"
msgstr "Consecutive hour"

msgid "Continue"
msgstr "Continue"

msgid "Contract"
msgstr "Contract"

msgid "Copy"
msgstr "Copy"

msgid "Correct"
msgstr "Correct"

msgid "Correct the highlighted time clock fields, then try again."
msgstr "Correct the highlighted time clock fields, then try again."

msgid "Cost type"
msgstr "Cost type"

msgid "Could not open the window. Please enable popups for this site."
msgstr "Could not open the window. Please enable popups for this site."

msgid "Create"
msgstr "Create"

msgid "Create a new crew timesheet"
msgstr "Create a new crew timesheet"

msgid "Create a new timesheet"
msgstr "Create a new timesheet"

msgid "Create a row to add your first entry."
msgstr "Create a row to add your first entry."

msgid "Create break"
msgstr "Create break"

msgid "Create crew timesheet"
msgstr "Create crew timesheet"

msgid "Create leave policy"
msgstr "Create leave policy"

msgid "Create manual entries"
msgstr "Create manual entries"

msgid "Create overtime ruleset"
msgstr "Create overtime ruleset"

msgid "Create rate card"
msgstr "Create rate card"

msgid "Create time clock"
msgstr "Create time clock"

msgid "Create timesheet"
msgstr "Create timesheet"

msgid "Created"
msgstr "Created"

msgid "Creating..."
msgstr "Creating..."

msgid "Crew ID"
msgstr "Crew ID"

msgid "crew member"
msgstr "crew member"

msgid "Crew name"
msgstr "Crew name"

msgid "Crew timesheet"
msgstr "Crew timesheet"

msgid "Crew timesheet | Sage Intelligent Time"
msgstr "Crew timesheet | Sage Intelligent Time"

msgid "Crew timesheets"
msgstr "Crew timesheets"

msgid "Crew timesheets | Sage Intelligent Time"
msgstr "Crew timesheets | Sage Intelligent Time"

msgid "Current Balance"
msgstr "Current Balance"

msgid "Current balance period started {formattedUsedSince}"
msgstr "Current balance period started {formattedUsedSince}"

msgid "Current balance:"
msgstr "Current balance:"

msgid "Custom"
msgstr "Custom"

msgid "Custom Formula"
msgstr "Custom Formula"

msgid "Custom timezone"
msgstr "Custom timezone"

msgid "Customer"
msgstr "Customer"

msgid "Daily"
msgstr "Daily"

msgid "Data retention for all employees"
msgstr "Data retention for all employees"

msgid "Data retention period"
msgstr "Data retention period"

msgid "Data sources | Sage Intelligent Time"
msgstr "Data sources | Sage Intelligent Time"

msgid "Data you provide: Calendar information from the time you give consent onward and the week prior to consent date, including content like event description and attachment names, header information like sender, recipients and start and end time, and metadata like created and updated dates."
msgstr "Data you provide: Calendar information from the time you give consent onward and the week prior to consent date, including content like event description and attachment names, header information like sender, recipients and start and end time, and metadata like created and updated dates."

msgid "Data you provide: Email information from the time you give consent onward, including header information like subject, sender, recipients and sent time stamp, and metadata like created and updated dates."
msgstr "Data you provide: Email information from the time you give consent onward, including header information like subject, sender, recipients and sent time stamp, and metadata like created and updated dates."

msgid "Date"
msgstr "Date"

msgid "Day"
msgstr "Day"

msgid "days"
msgstr "days"

msgid "days after the end of the timesheet period"
msgstr "days after the end of the timesheet period"

msgid "days after the start of the timesheet period"
msgstr "days after the start of the timesheet period"

msgid "Days per year"
msgstr "Days per year"

msgid "Days to accrue"
msgstr "Days to accrue"

msgid "Deactivate"
msgstr "Deactivate"

msgid "Decline"
msgstr "Decline"

msgid "Decline lines"
msgstr "Decline lines"

msgid "Decline request"
msgstr "Decline request"

msgid "Decline time entries"
msgstr "Decline time entries"

msgid "Decline timesheets"
msgstr "Decline timesheets"

msgid "Declined"
msgstr "Declined"

msgid "Declined by: {approvedByName}."
msgstr "Declined by: {approvedByName}."

msgid "Declined by: {approvedByName}. Notes: {comments}"
msgstr "Declined by: {approvedByName}. Notes: {comments}"

msgid "Declined by: {approverName}."
msgstr "Declined by: {approverName}."

msgid "Declining entries, we'll notify you when we finish."
msgstr "Declining entries, we'll notify you when we finish."

msgid "Declining timesheets, we'll notify you when we finish."
msgstr "Declining timesheets, we'll notify you when we finish."

msgid "Declining..."
msgstr "Declining..."

msgid "Default show weekend"
msgstr "Default show weekend"

msgid "Define the conditions and calculations for overtime pay"
msgstr "Define the conditions and calculations for overtime pay"

msgid "Delegated"
msgstr "Delegated"

msgid "Delegated for {originalApproverName}"
msgstr "Delegated for {originalApproverName}"

msgid "Delete"
msgstr "Delete"

msgid "Delete account"
msgstr "Delete account"

msgid "Delete activity"
msgstr "Delete activity"

msgid "Delete activity cards"
msgstr "Delete activity cards"

msgid "Delete and re-connect account"
msgstr "Delete and re-connect account"

msgid "Delete break"
msgstr "Delete break"

msgid "Delete clock out time"
msgstr "Delete clock out time"

msgid "Delete crew member"
msgstr "Delete crew member"

msgid "Delete crew member {crewMemberName}"
msgstr "Delete crew member {crewMemberName}"

msgid "Delete file"
msgstr "Delete file"

msgid "Delete rate card"
msgstr "Delete rate card"

msgid "Delete row"
msgstr "Delete row"

msgid "Delete rule group"
msgstr "Delete rule group"

msgid "Delete work location"
msgstr "Delete work location"

msgid "Deleting"
msgstr "Deleting"

msgid "Deleting the row will reset all assigned activities."
msgstr "Deleting the row will reset all assigned activities."

msgid "Deleting..."
msgstr "Deleting..."

msgid "Demo preferences"
msgstr "Demo preferences"

msgid "Denied"
msgstr "Denied"

msgid "Department"
msgstr "Department"

msgid "Description"
msgstr "Description"

msgid "Details"
msgstr "Details"

msgid "Did not attend"
msgstr "Did not attend"

msgid "Dimensions"
msgstr "Dimensions"

msgid "Dimensions order"
msgstr "Dimensions order"

msgid "Disclosed to: The Sage Group plc or a subsidiary (the controller, as to you; the processor, as to your employer)."
msgstr "Disclosed to: The Sage Group plc or a subsidiary (the controller, as to you; the processor, as to your employer)."

msgid "Disconnect"
msgstr "Disconnect"

msgid "Display Intacct ID"
msgstr "Display Intacct ID"

msgid "Distance"
msgstr "Distance"

msgid "Distance units"
msgstr "Distance units"

msgid "Don't show this message again"
msgstr "Don't show this message again"

msgid "Done"
msgstr "Done"

msgid "Down"
msgstr "Down"

msgid "Download"
msgstr "Download"

msgid "Download app"
msgstr "Download app"

msgid "download on the app store"
msgstr "download on the app store"

msgid "Download the Time Assistant"
msgstr "Download the Time Assistant"

msgid "Download the Time Assistant to track time spent on your Mac or PC."
msgstr "Download the Time Assistant to track time spent on your Mac or PC."

msgid "Download Time Assistant"
msgstr "Download Time Assistant"

msgid "Draft"
msgstr "Draft"

msgid "Draft with AI Assistant"
msgstr "Draft with AI Assistant"

msgid "Drag and drop your activity"
msgstr "Drag and drop your activity"

msgid "Drag and drop your files"
msgstr "Drag and drop your files"

msgid "Drop your activity here"
msgstr "Drop your activity here"

msgid "Drop your files here"
msgstr "Drop your files here"

msgid "Duplicate"
msgstr "Duplicate"

msgid "Duplicate crew timesheet"
msgstr "Duplicate crew timesheet"

msgid "Duplicate timesheet"
msgstr "Duplicate timesheet"

msgid "Duration"
msgstr "Duration"

msgid "Duration: half day"
msgstr "Duration: half day"

msgid "e.g., 15 + (employeeTenureYears * 0.5)"
msgstr "e.g., 15 + (employeeTenureYears * 0.5)"

msgid "e.g., 5 to add or -3 to deduct"
msgstr "e.g., 5 to add or -3 to deduct"

msgid "e.g., Standard PTO Policy"
msgstr "e.g., Standard PTO Policy"

msgid "Each tenure tier must use a unique years of service value"
msgstr "Each tenure tier must use a unique years of service value"

msgid "Each tenure tier needs years of service and an annual amount"
msgstr "Each tenure tier needs years of service and an annual amount"

msgid "Edit"
msgstr "Edit"

msgid "Edit formula manually"
msgstr "Edit formula manually"

msgid "Edit leave request"
msgstr "Edit leave request"

msgid "Edit notes"
msgstr "Edit notes"

msgid "Edit rate card"
msgstr "Edit rate card"

msgid "Edit request"
msgstr "Edit request"

msgid "Edit time clock"
msgstr "Edit time clock"

msgid "Edit work location"
msgstr "Edit work location"

msgid "Effective date"
msgstr "Effective date"

msgid "Effective date is required"
msgstr "Effective date is required"

msgid "Email"
msgstr "Email"

msgid "Email activity"
msgstr "Email activity"

msgid "Email not connected"
msgstr "Email not connected"

msgid "Email synced successfully"
msgstr "Email synced successfully"

msgid "Employee"
msgstr "Employee"

msgid "Employee group"
msgstr "Employee group"

msgid "Employee ID"
msgstr "Employee ID"

msgid "Employee is required"
msgstr "Employee is required"

msgid "Employee name"
msgstr "Employee name"

msgid "Employee overtime assignments"
msgstr "Employee overtime assignments"

msgid "Employee overtime comment"
msgstr "Employee overtime comment"

msgid "Employee position"
msgstr "Employee position"

msgid "Employee search (showing {currentEmployeeCount}/{totalEmployees})"
msgstr "Employee search (showing {currentEmployeeCount}/{totalEmployees})"

msgid "Employee's current leave balance"
msgstr "Employee's current leave balance"

msgid "Employees assigned to this ruleset"
msgstr "Employees assigned to this ruleset"

msgid "Employees assigned to this work location"
msgstr "Employees assigned to this work location"

msgid "Enable this to include the Intacct ID in dimension value names."
msgstr "Enable this to include the Intacct ID in dimension value names."

msgid "End break"
msgstr "End break"

msgid "End date"
msgstr "End date"

msgid "Enter a comment to explain the discrepancy. This will be included in the timesheet submission."
msgstr "Enter a comment to explain the discrepancy. This will be included in the timesheet submission."

msgid "Enter a reason for the location violation before clocking out."
msgstr "Enter a reason for the location violation before clocking out."

msgid "Entity"
msgstr "Entity"

msgid "Entries"
msgstr "Entries"

msgid "Entries approvals | Sage Intelligent Time"
msgstr "Entries approvals | Sage Intelligent Time"

msgid "Entry date"
msgstr "Entry date"

msgid "Entry details"
msgstr "Entry details"

msgid "Entry details order"
msgstr "Entry details order"

msgid "Entry status"
msgstr "Entry status"

msgid "Equal Monthly"
msgstr "Equal Monthly"

msgid "Error"
msgstr "Error"

msgid "Error assigning overtime rulesets."
msgstr "Error assigning overtime rulesets."

msgid "Error loading employees for this overtime ruleset."
msgstr "Error loading employees for this overtime ruleset."

msgid "Error loading employees for this work location."
msgstr "Error loading employees for this work location."

msgid "Error loading employees."
msgstr "Error loading employees."

msgid "Error unassigning overtime rulesets."
msgstr "Error unassigning overtime rulesets."

msgid "Event date"
msgstr "Event date"

msgid "Excess hours"
msgstr "Excess hours"

msgid "Exclude time types from accrual"
msgstr "Exclude time types from accrual"

msgid "Expand"
msgstr "Expand"

msgid "Expand all"
msgstr "Expand all"

msgid "Expand crew member rows"
msgstr "Expand crew member rows"

msgid "Expiration date"
msgstr "Expiration date"

msgid "Expiration date must be after effective date"
msgstr "Expiration date must be after effective date"

msgid "Failed to adjust leave balance"
msgstr "Failed to adjust leave balance"

msgid "Failed to approve"
msgstr "Failed to approve"

msgid "Failed to approve: {reason}"
msgstr "Failed to approve: {reason}"

msgid "Failed to create leave policy: {message}"
msgstr "Failed to create leave policy: {message}"

msgid "Failed to decline"
msgstr "Failed to decline"

msgid "Failed to decline: {reason}"
msgstr "Failed to decline: {reason}"

msgid "Failed to load approval relationships. Please try again."
msgstr "Failed to load approval relationships. Please try again."

msgid "Failed to load balance adjustments. Please try again."
msgstr "Failed to load balance adjustments. Please try again."

msgid "Failed to load leave balances. Please try refreshing the page."
msgstr "Failed to load leave balances. Please try refreshing the page."

msgid "Failed to load leave requests. Please try refreshing the page."
msgstr "Failed to load leave requests. Please try refreshing the page."

msgid "Failed to load team leave. Please try refreshing the page."
msgstr "Failed to load team leave. Please try refreshing the page."

msgid "Failed to process"
msgstr "Failed to process"

msgid "Failed to process: {reason}"
msgstr "Failed to process: {reason}"

msgid "Failed to update leave policy: {message}"
msgstr "Failed to update leave policy: {message}"

msgid "Feet"
msgstr "Feet"

msgid "Field"
msgstr "Field"

msgid "File uploaded"
msgstr "File uploaded"

msgid "File uploading..."
msgstr "File uploading..."

msgid "File with the same name already exists"
msgstr "File with the same name already exists"

msgid "Fixed Amount"
msgstr "Fixed Amount"

msgid "Fixed asset"
msgstr "Fixed asset"

msgid "For assistance, please contact Intacct Support by <0>submitting a support ticket in the community portal</0> or writing Sage Intacct, ATTN: Support, 300 Park Ave, Suite 1400, San Jose, CA 95110."
msgstr "For assistance, please contact Intacct Support by <0>submitting a support ticket in the community portal</0> or writing Sage Intacct, ATTN: Support, 300 Park Ave, Suite 1400, San Jose, CA 95110."

msgid "For overtime guidelines per state: <0>check here</0>."
msgstr "For overtime guidelines per state: <0>check here</0>."

msgid "Forgot your password?"
msgstr "Forgot your password?"

msgid "Formula expression"
msgstr "Formula expression"

msgid "Friday"
msgstr "Friday"

msgid "Front Loaded"
msgstr "Front Loaded"

msgid "Gather activities from"
msgstr "Gather activities from"

msgid "Generate activity cards"
msgstr "Generate activity cards"

msgid "Generate activity cards for this user"
msgstr "Generate activity cards for this user"

msgid "Generated formula"
msgstr "Generated formula"

msgid "Generating..."
msgstr "Generating..."

msgid "get it on play store"
msgstr "get it on play store"

msgid "Give bonus days after a certain number of years"
msgstr "Give bonus days after a certain number of years"

msgid "GL post date"
msgstr "GL post date"

msgid "Gmail"
msgstr "Gmail"

msgid "Go back"
msgstr "Go back"

msgid "Go to Intacct"
msgstr "Go to Intacct"

msgid "Google account"
msgstr "Google account"

msgid "Google Calendar"
msgstr "Google Calendar"

msgid "Google Email"
msgstr "Google Email"

msgid "Got it"
msgstr "Got it"

msgid "Group {groupNumber}"
msgstr "Group {groupNumber}"

msgid "half day"
msgstr "half day"

msgid "Half day"
msgstr "Half day"

msgid "Help"
msgstr "Help"

msgid "Highlighted location"
msgstr "Highlighted location"

msgid "History"
msgstr "History"

msgid "Holiday"
msgstr "Holiday"

msgid "Holidays (excluded):"
msgstr "Holidays (excluded):"

msgid "Holidays:"
msgstr "Holidays:"

msgid "Hourly Percent"
msgstr "Hourly Percent"

msgid "Hours"
msgstr "Hours"

msgid "Hours logged with the selected {timeTypeTerminology} values will not count toward hourly percent leave accrual."
msgstr "Hours logged with the selected {timeTypeTerminology} values will not count toward hourly percent leave accrual."

msgid "Hours per day"
msgstr "Hours per day"

msgid "How the overtime is calculated"
msgstr "How the overtime is calculated"

msgid "How to opt out: Click \"disconnect\" next to the account in the time sources page."
msgstr "How to opt out: Click \"disconnect\" next to the account in the time sources page."

msgid "Hrs."
msgstr "Hrs."

msgid "ID"
msgstr "ID"

msgid "If enabled, this work location will apply to all employees regardless of their assigned location. If disabled, only employees assigned to this location will be affected."
msgstr "If enabled, this work location will apply to all employees regardless of their assigned location. If disabled, only employees assigned to this location will be affected."

msgid "In order to re-connect your account, you'll need to delete this connection and then connect your account again. This will delete all data associated with this time source."
msgstr "In order to re-connect your account, you'll need to delete this connection and then connect your account again. This will delete all data associated with this time source."

msgid "In progress"
msgstr "In progress"

msgid "In your browser's settings, add <0>{appUrl}</0> to the list of sites allowed to use third-party cookies."
msgstr "In your browser's settings, add <0>{appUrl}</0> to the list of sites allowed to use third-party cookies."

msgid "Inactive"
msgstr "Inactive"

msgid "Include entity data"
msgstr "Include entity data"

msgid "Include entries"
msgstr "Include entries"

msgid "Include inactive"
msgstr "Include inactive"

msgid "Install the application to capture computer activity."
msgstr "Install the application to capture computer activity."

msgid "Intacct company ID"
msgstr "Intacct company ID"

msgid "Intacct doesn't allow blank timesheets, add a new row with at least one entry to be able to delete this row."
msgstr "Intacct doesn't allow blank timesheets, add a new row with at least one entry to be able to delete this row."

msgid "Intacct user ID"
msgstr "Intacct user ID"

msgid "Intelligent Time"
msgstr "Intelligent Time"

msgid "Internet connection restored"
msgstr "Internet connection restored"

msgid "Invalid date"
msgstr "Invalid date"

msgid "Invalid navop value: {navopStr}"
msgstr "Invalid navop value: {navopStr}"

msgid "Invalid number"
msgstr "Invalid number"

msgid "Invalid phone number"
msgstr "Invalid phone number"

msgid "Invalid start date. Select a date that is on {weekStartDay}."
msgstr "Invalid start date. Select a date that is on {weekStartDay}."

msgid "Invalid start date. Select the 1st or the 16th of the month."
msgstr "Invalid start date. Select the 1st or the 16th of the month."

msgid "Invalid time clock ID"
msgstr "Invalid time clock ID"

msgid "Invitation sent"
msgstr "Invitation sent"

msgid "Invoiced"
msgstr "Invoiced"

msgid "Item"
msgstr "Item"

msgid "Join us in Sage Intacct"
msgstr "Join us in Sage Intacct"

msgid "Labor class"
msgstr "Labor class"

msgid "Labor shift"
msgstr "Labor shift"

msgid "Labor union"
msgstr "Labor union"

msgid "Last synced {lastSyncedTime}."
msgstr "Last synced {lastSyncedTime}."

msgid "Launch"
msgstr "Launch"

msgid "Leave"
msgstr "Leave"

msgid "Leave | Sage Intelligent Time"
msgstr "Leave | Sage Intelligent Time"

msgid "Leave approvals"
msgstr "Leave approvals"

msgid "Leave approvals | Sage Intelligent Time"
msgstr "Leave approvals | Sage Intelligent Time"

msgid "Leave balance adjusted successfully"
msgstr "Leave balance adjusted successfully"

msgid "Leave blank for no cap"
msgstr "Leave blank for no cap"

msgid "Leave days:"
msgstr "Leave days:"

msgid "Leave policies"
msgstr "Leave policies"

msgid "Leave policy configuration"
msgstr "Leave policy configuration"

msgid "Leave policy created successfully"
msgstr "Leave policy created successfully"

msgid "Leave policy deleted successfully"
msgstr "Leave policy deleted successfully"

msgid "Leave policy updated successfully"
msgstr "Leave policy updated successfully"

msgid "Leave request"
msgstr "Leave request"

msgid "Leave request approved"
msgstr "Leave request approved"

msgid "Leave request cancelled successfully"
msgstr "Leave request cancelled successfully"

msgid "Leave request declined"
msgstr "Leave request declined"

msgid "Leave request submitted successfully"
msgstr "Leave request submitted successfully"

msgid "Leave request updated successfully"
msgstr "Leave request updated successfully"

msgid "Leave requests"
msgstr "Leave requests"

msgid "Leave summary"
msgstr "Leave summary"

msgid "Leave type"
msgstr "Leave type"

msgid "Loading balance adjustments…"
msgstr "Loading balance adjustments…"

msgid "Loading leave approvals…"
msgstr "Loading leave approvals…"

msgid "Loading map..."
msgstr "Loading map..."

msgid "Loading work location..."
msgstr "Loading work location..."

msgid "Loading work locations..."
msgstr "Loading work locations..."

msgid "Loading..."
msgstr "Loading..."

msgid "Location"
msgstr "Location"

msgid "Location summary"
msgstr "Location summary"

msgid "Location was not captured for this time clock."
msgstr "Location was not captured for this time clock."

msgid "Log in"
msgstr "Log in"

msgid "Log in menu"
msgstr "Log in menu"

msgid "Logged in as"
msgstr "Logged in as"

msgid "Login | Sage Intelligent Time"
msgstr "Login | Sage Intelligent Time"

msgid "Logout"
msgstr "Logout"

msgid "Maintain full control over your connected time sources - see our <0>privacy policy</0> to learn more"
msgstr "Maintain full control over your connected time sources - see our <0>privacy policy</0> to learn more"

msgid "Maintenance mode"
msgstr "Maintenance mode"

msgid "Manage attachments"
msgstr "Manage attachments"

msgid "Manage how you receive notifications."
msgstr "Manage how you receive notifications."

msgid "Manage overtime settings."
msgstr "Manage overtime settings."

msgid "Manage the hours when activities are gathered, hour rounding and more."
msgstr "Manage the hours when activities are gathered, hour rounding and more."

msgid "Manage timesheet notifications"
msgstr "Manage timesheet notifications"

msgid "Manage work locations and assign employees to each location."
msgstr "Manage work locations and assign employees to each location."

msgid "Manager"
msgstr "Manager"

msgid "Maximum carry-over days"
msgstr "Maximum carry-over days"

msgid "Merge entries"
msgstr "Merge entries"

msgid "Merged with existing row"
msgstr "Merged with existing row"

msgid "Meters"
msgstr "Meters"

msgid "Microsoft account"
msgstr "Microsoft account"

msgid "Microsoft Outlook"
msgstr "Microsoft Outlook"

msgid "Microsoft Outlook Calendar"
msgstr "Microsoft Outlook Calendar"

msgid "Microsoft Outlook Email"
msgstr "Microsoft Outlook Email"

msgid "Mins."
msgstr "Mins."

msgid "minutes"
msgstr "minutes"

msgid "Misapplied hours"
msgstr "Misapplied hours"

msgid "Missing hours"
msgstr "Missing hours"

msgid "Missing permissions"
msgstr "Missing permissions"

msgid "Missing required fragment parameters"
msgstr "Missing required fragment parameters"

msgid "Mobile"
msgstr "Mobile"

msgid "Monday"
msgstr "Monday"

msgid "Monthly"
msgstr "Monthly"

msgid "Months with the company"
msgstr "Months with the company"

msgid "Move to entry details"
msgstr "Move to entry details"

msgid "Move to timesheet row"
msgstr "Move to timesheet row"

msgid "Move to trash"
msgstr "Move to trash"

msgid "Multiplier"
msgstr "Multiplier"

msgid "Multiplier must be greater than or equal to 1"
msgstr "Multiplier must be greater than or equal to 1"

msgid "Must be a valid number"
msgstr "Must be a valid number"

msgid "My leave"
msgstr "My leave"

msgid "My leave | Sage Intelligent Time"
msgstr "My leave | Sage Intelligent Time"

msgid "My leave summary"
msgstr "My leave summary"

msgid "My time clocks"
msgstr "My time clocks"

msgid "My timesheet"
msgstr "My timesheet"

msgid "My timesheets"
msgstr "My timesheets"

msgid "N/A"
msgstr "N/A"

msgid "Name"
msgstr "Name"

msgid "Name is required"
msgstr "Name is required"

msgid "Nearest"
msgstr "Nearest"

msgid "Negative hours"
msgstr "Negative hours"

msgid "New entry"
msgstr "New entry"

msgid "New negative row"
msgstr "New negative row"

msgid "New row"
msgstr "New row"

msgid "Next days"
msgstr "Next days"

msgid "Next employees"
msgstr "Next employees"

msgid "Next month"
msgstr "Next month"

msgid "No"
msgstr "No"

msgid "No active {timeTypeTerminology} values are available to exclude."
msgstr "No active {timeTypeTerminology} values are available to exclude."

msgid "No activities to assign"
msgstr "No activities to assign"

msgid "No allocations available. Create allocations on Intacct to continue."
msgstr "No allocations available. Create allocations on Intacct to continue."

msgid "No approval history"
msgstr "No approval history"

msgid "No approver user"
msgstr "No approver user"

msgid "No assigned activities"
msgstr "No assigned activities"

msgid "No balance adjustments yet."
msgstr "No balance adjustments yet."

msgid "No breaks recorded for this time clock"
msgstr "No breaks recorded for this time clock"

msgid "No calendars selected. Connect a calendar below to retrieve calendar events."
msgstr "No calendars selected. Connect a calendar below to retrieve calendar events."

msgid "No clock-in location available"
msgstr "No clock-in location available"

msgid "No completed leave approvals found."
msgstr "No completed leave approvals found."

msgid "No data"
msgstr "No data"

msgid "No data."
msgstr "No data."

msgid "No employees assigned to this overtime ruleset."
msgstr "No employees assigned to this overtime ruleset."

msgid "No employees assigned to this work location."
msgstr "No employees assigned to this work location."

msgid "No employees in this entity."
msgstr "No employees in this entity."

msgid "No entries recorded for this rate card"
msgstr "No entries recorded for this rate card"

msgid "No info"
msgstr "No info"

msgid "No internet connection"
msgstr "No internet connection"

msgid "No leave approval relationships found."
msgstr "No leave approval relationships found."

msgid "No leave requests found."
msgstr "No leave requests found."

msgid "No leave requests require your approval right now."
msgstr "No leave requests require your approval right now."

msgid "No locations to display on the map"
msgstr "No locations to display on the map"

msgid "No manager"
msgstr "No manager"

msgid "No overtime rules or rule groups configured. Click \"Add rule\" or \"Add rule group\" to get started."
msgstr "No overtime rules or rule groups configured. Click \"Add rule\" or \"Add rule group\" to get started."

msgid "No overtime rulesets are currently assigned to the selected employees."
msgstr "No overtime rulesets are currently assigned to the selected employees."

msgid "No rate cards found"
msgstr "No rate cards found"

msgid "No results"
msgstr "No results"

msgid "No results found"
msgstr "No results found"

msgid "No rules in this group. Add at least two rules to proceed."
msgstr "No rules in this group. Add at least two rules to proceed."

msgid "No team leave scheduled for the selected period."
msgstr "No team leave scheduled for the selected period."

msgid "No team members found."
msgstr "No team members found."

msgid "No time clocks found"
msgstr "No time clocks found"

msgid "No time clocks selected for deletion"
msgstr "No time clocks selected for deletion"

msgid "No time sources connected"
msgstr "No time sources connected"

msgid "No work locations"
msgstr "No work locations"

msgid "Node"
msgstr "Node"

msgid "Non-billable hours"
msgstr "Non-billable hours"

msgid "None"
msgstr "None"

msgid "Not assigned"
msgstr "Not assigned"

msgid "Not found"
msgstr "Not found"

msgid "Not invited"
msgstr "Not invited"

msgid "Not set"
msgstr "Not set"

msgid "Notes"
msgstr "Notes"

msgid "Notes and dimensions"
msgstr "Notes and dimensions"

msgid "Notice: Access Sage Intelligent Time from Sage Intacct"
msgstr "Notice: Access Sage Intelligent Time from Sage Intacct"

msgid "Notification icon"
msgstr "Notification icon"

msgid "Notifications"
msgstr "Notifications"

msgid "Notify me via:"
msgstr "Notify me via:"

msgid "Notify me when:"
msgstr "Notify me when:"

msgid "Number of days (0-7)"
msgstr "Number of days (0-7)"

msgid "Number of hours (0-168)"
msgstr "Number of hours (0-168)"

msgid "Number of hours (0-24)"
msgstr "Number of hours (0-24)"

msgid "Offsite location (e.g. remote work, client site)"
msgstr "Offsite location (e.g. remote work, client site)"

msgid "OK"
msgstr "OK"

msgid "on the selected days"
msgstr "on the selected days"

msgid "Only employee groups with specific members are supported"
msgstr "Only employee groups with specific members are supported"

msgid "Oops! We can't connect to the server right now. Please wait a few minutes before refreshing the page."
msgstr "Oops! We can't connect to the server right now. Please wait a few minutes before refreshing the page."

msgid "Optional policy description"
msgstr "Optional policy description"

msgid "Optional: add comments for the employee"
msgstr "Optional: add comments for the employee"

msgid "Outlook Calendar"
msgstr "Outlook Calendar"

msgid "Outlook Email"
msgstr "Outlook Email"

msgid "Outside allowed work location"
msgstr "Outside allowed work location"

msgid "Overtime"
msgstr "Overtime"

msgid "Overtime details"
msgstr "Overtime details"

msgid "Overtime discrepancy warning"
msgstr "Overtime discrepancy warning"

msgid "Overtime has been applied successfully. Review the timesheet entries to ensure the splits match your expectations."
msgstr "Overtime has been applied successfully. Review the timesheet entries to ensure the splits match your expectations."

msgid "Overtime hours may not be correctly applied. Please review the table above."
msgstr "Overtime hours may not be correctly applied. Please review the table above."

msgid "Overtime is not supported for this entity because {timeTypeTerminology} is not enabled."
msgstr "Overtime is not supported for this entity because {timeTypeTerminology} is not enabled."

msgid "Overtime is only supported for daily and weekly timesheets. This entity's timesheet duration is {timesheetDurationName}."
msgstr "Overtime is only supported for daily and weekly timesheets. This entity's timesheet duration is {timesheetDurationName}."

msgid "Overtime multiplier applied to entries matched by this group"
msgstr "Overtime multiplier applied to entries matched by this group"

msgid "Overtime multiplier applied to the timesheet entry"
msgstr "Overtime multiplier applied to the timesheet entry"

msgid "Overtime rule name"
msgstr "Overtime rule name"

msgid "Overtime rules"
msgstr "Overtime rules"

msgid "Overtime ruleset configuration"
msgstr "Overtime ruleset configuration"

msgid "Overtime ruleset to reassign"
msgstr "Overtime ruleset to reassign"

msgid "Overtime rulesets"
msgstr "Overtime rulesets"

msgid "Overtime rulesets to unassign"
msgstr "Overtime rulesets to unassign"

msgid "Page not found"
msgstr "Page not found"

msgid "Page not found | Sage Intelligent Time"
msgstr "Page not found | Sage Intelligent Time"

msgid "page not found asset"
msgstr "page not found asset"

msgid "Partially approved"
msgstr "Partially approved"

msgid "Partially declined"
msgstr "Partially declined"

msgid "Password"
msgstr "Password"

msgid "Pay Period"
msgstr "Pay Period"

msgid "Pay periods per year"
msgstr "Pay periods per year"

msgid "Pending"
msgstr "Pending"

msgid "Pending delete"
msgstr "Pending delete"

msgid "Pending leave"
msgstr "Pending leave"

msgid "Percent of hours"
msgstr "Percent of hours"

msgid "Personalize your timesheet and time entry views."
msgstr "Personalize your timesheet and time entry views."

msgid "Please add at least one entry with a duration."
msgstr "Please add at least one entry with a duration."

msgid "Please address all timesheet header and entry errors below and re-submit the timesheet."
msgstr "Please address all timesheet header and entry errors below and re-submit the timesheet."

msgid "Please complete the form below to finish clocking out."
msgstr "Please complete the form below to finish clocking out."

msgid "Please enter a number between {lowerBound} and {upperBound}"
msgstr "Please enter a number between {lowerBound} and {upperBound}"

msgid "Please select an employee"
msgstr "Please select an employee"

msgid "Please select the date, customer, project, and task that you’d like activity cards to demo. Four cards with varying predictions will be generated for the selected date and available on all timesheets that include that date. If you’re having issues, please ensure this user is assigned to projects and tasks with valid dates and active customers in Intacct and then <0>Sync manually </0>and try again. Please see <1>HighSpot</1> for details."
msgstr "Please select the date, customer, project, and task that you’d like activity cards to demo. Four cards with varying predictions will be generated for the selected date and available on all timesheets that include that date. If you’re having issues, please ensure this user is assigned to projects and tasks with valid dates and active customers in Intacct and then <0>Sync manually </0>and try again. Please see <1>HighSpot</1> for details."

msgid "Please try again or contact support."
msgstr "Please try again or contact support."

msgid "Please try again. If the error persists, please contact support."
msgstr "Please try again. If the error persists, please contact support."

msgid "Please wait for the previous action to complete before deleting a row."
msgstr "Please wait for the previous action to complete before deleting a row."

msgid "PM"
msgstr "PM"

msgid "Point location"
msgstr "Point location"

msgid "Policy details"
msgstr "Policy details"

msgid "Policy name"
msgstr "Policy name"

msgid "Policy name is required"
msgstr "Policy name is required"

msgid "Powered by Ai"
msgstr "Powered by Ai"

msgid "Predefined overtime rulesets are a convenience feature that provides a set of common rules used to calculate overtime. However, Sage Intacct is not responsible for the accuracy of these rulesets. We do not update rulesets based on the latest values. If the legal requirements change, you must create a new ruleset. You should verify the rules with the employee's relevant laws and regulations, as we may show outdated or incorrect values."
msgstr "Predefined overtime rulesets are a convenience feature that provides a set of common rules used to calculate overtime. However, Sage Intacct is not responsible for the accuracy of these rulesets. We do not update rulesets based on the latest values. If the legal requirements change, you must create a new ruleset. You should verify the rules with the employee's relevant laws and regulations, as we may show outdated or incorrect values."

msgid "Predefined ruleset template"
msgstr "Predefined ruleset template"

msgid "Predefined ruleset template (optional)"
msgstr "Predefined ruleset template (optional)"

msgid "Predefined template"
msgstr "Predefined template"

msgid "Preview"
msgstr "Preview"

msgid "Previous days"
msgstr "Previous days"

msgid "Previous employees"
msgstr "Previous employees"

msgid "Previous month"
msgstr "Previous month"

msgid "Print"
msgstr "Print"

msgid "Privacy"
msgstr "Privacy"

msgid "Privacy Policy | Sage Intelligent Time"
msgstr "Privacy Policy | Sage Intelligent Time"

msgid "Proceed"
msgstr "Proceed"

msgid "Processing"
msgstr "Processing"

msgid "Profile menu"
msgstr "Profile menu"

msgid "Project"
msgstr "Project"

msgid "Provide a brief reason for your leave request"
msgstr "Provide a brief reason for your leave request"

msgid "Provide a reason for this balance adjustment"
msgstr "Provide a reason for this balance adjustment"

msgid "Provider"
msgstr "Provider"

msgid "PTO"
msgstr "PTO"

msgid "PTO (approved)"
msgstr "PTO (approved)"

msgid "PTO (pending)"
msgstr "PTO (pending)"

msgid "PTO accrual"
msgstr "PTO accrual"

msgid "PTO accrual method is required"
msgstr "PTO accrual method is required"

msgid "PTO accrual rule"
msgstr "PTO accrual rule"

msgid "PTO leave balance"
msgstr "PTO leave balance"

msgid "Pull in {source}'s events to auto-generate entries."
msgstr "Pull in {source}'s events to auto-generate entries."

msgid "Pull in calendar events to auto-generate entries."
msgstr "Pull in calendar events to auto-generate entries."

msgid "Pull in emails to auto-generate timesheet entries."
msgstr "Pull in emails to auto-generate timesheet entries."

msgid "Radius"
msgstr "Radius"

msgid "Rate"
msgstr "Rate"

msgid "Rate card deleted successfully"
msgstr "Rate card deleted successfully"

msgid "Rate card entries updated successfully"
msgstr "Rate card entries updated successfully"

msgid "Rate card ID not found"
msgstr "Rate card ID not found"

msgid "Rate card updated successfully"
msgstr "Rate card updated successfully"

msgid "Rate cards"
msgstr "Rate cards"

msgid "Rate cards | Sage Intelligent Time"
msgstr "Rate cards | Sage Intelligent Time"

msgid "Re-center map"
msgstr "Re-center map"

msgid "Re-connect"
msgstr "Re-connect"

msgid "Re-connect account"
msgstr "Re-connect account"

msgid "Re-download"
msgstr "Re-download"

msgid "Ready"
msgstr "Ready"

msgid "Rearrange the order of dimensions in your entry details view by dragging and dropping."
msgstr "Rearrange the order of dimensions in your entry details view by dragging and dropping."

msgid "Rearrange the order of dimensions in your timesheet view by dragging and dropping."
msgstr "Rearrange the order of dimensions in your timesheet view by dragging and dropping."

msgid "Reason"
msgstr "Reason"

msgid "Reason for violation"
msgstr "Reason for violation"

msgid "Reason: {reason}"
msgstr "Reason: {reason}"

msgid "Reassign"
msgstr "Reassign"

msgid "Reassign overtime rulesets"
msgstr "Reassign overtime rulesets"

msgid "Reassign overtime rulesets from employee."
msgstr "Reassign overtime rulesets from employee."

msgid "Reassigning..."
msgstr "Reassigning..."

msgid "Recall"
msgstr "Recall"

msgid "Recalling timesheet"
msgstr "Recalling timesheet"

msgid "Receive an email alert when a sync is unsuccessful"
msgstr "Receive an email alert when a sync is unsuccessful"

msgid "Recorded"
msgstr "Recorded"

msgid "Remind me later"
msgstr "Remind me later"

msgid "Remove"
msgstr "Remove"

#. placeholder {0}: item.name
msgid "Remove {0}"
msgstr "Remove {0}"

msgid "Request failed"
msgstr "Request failed"

msgid "Request leave"
msgstr "Request leave"

msgid "Request leave for an employee"
msgstr "Request leave for an employee"

msgid "Request only half a day (0.5 days)"
msgstr "Request only half a day (0.5 days)"

msgid "Requested leave days:"
msgstr "Requested leave days:"

msgid "Required"
msgstr "Required"

msgid "Resolve missing overtime"
msgstr "Resolve missing overtime"

msgid "Resolve overtime"
msgstr "Resolve overtime"

msgid "Retain employee calendar data for"
msgstr "Retain employee calendar data for"

msgid "Retain employee email data for"
msgstr "Retain employee email data for"

msgid "Retain employee Time Assistant data for"
msgstr "Retain employee Time Assistant data for"

msgid "Retain my calendar data for"
msgstr "Retain my calendar data for"

msgid "Retain my email data for"
msgstr "Retain my email data for"

msgid "Retain my Time Assistant data for"
msgstr "Retain my Time Assistant data for"

msgid "Retained until: When connecting your account, you will be prompted to choose how long we retain your data. You can change this setting at any time."
msgstr "Retained until: When connecting your account, you will be prompted to choose how long we retain your data. You can change this setting at any time."

msgid "Retry"
msgstr "Retry"

msgid "Return to time sources"
msgstr "Return to time sources"

msgid "Reuse"
msgstr "Reuse"

msgid "Reuse this time clock"
msgstr "Reuse this time clock"

msgid "Review manager relationships to ensure leave approvals work correctly."
msgstr "Review manager relationships to ensure leave approvals work correctly."

msgid "Review request details"
msgstr "Review request details"

msgid "Rounding behavior"
msgstr "Rounding behavior"

msgid "Rounding behavior must be nearest, up, down, or none"
msgstr "Rounding behavior must be nearest, up, down, or none"

msgid "Rounding minutes"
msgstr "Rounding minutes"

msgid "Rounding minutes must be 0, 5, 6, or 15"
msgstr "Rounding minutes must be 0, 5, 6, or 15"

msgid "Rule {ruleNumber}"
msgstr "Rule {ruleNumber}"

msgid "Rules"
msgstr "Rules"

msgid "Rules within a group are combined with 'AND', where all rule conditions must be met to trigger overtime. Groups and rules outside of a group are combined with 'OR'."
msgstr "Rules within a group are combined with 'AND', where all rule conditions must be met to trigger overtime. Groups and rules outside of a group are combined with 'OR'."

msgid "Rules:"
msgstr "Rules:"

msgid "Ruleset name"
msgstr "Ruleset name"

msgid "Ruleset name is required"
msgstr "Ruleset name is required"

msgid "Rulesets (active date)"
msgstr "Rulesets (active date)"

msgid "Sage Intelligent Time"
msgstr "Sage Intelligent Time"

msgid "Sage Intelligent Time doesn't support the version of this web browser. Update your browser to the most current version. For more information, <0>view supported browsers</0>."
msgstr "Sage Intelligent Time doesn't support the version of this web browser. Update your browser to the most current version. For more information, <0>view supported browsers</0>."

msgid "Sage Intelligent Time is available anytime and anywhere with our mobile app."
msgstr "Sage Intelligent Time is available anytime and anywhere with our mobile app."

msgid "Sage Intelligent Time is currently undergoing scheduled maintenance, please check back around <0>{time}</0>."
msgstr "Sage Intelligent Time is currently undergoing scheduled maintenance, please check back around <0>{time}</0>."

msgid "Sage Intelligent Time is down for scheduled maintenance"
msgstr "Sage Intelligent Time is down for scheduled maintenance"

msgid "Sage Intelligent Time requires browser cookies to load."
msgstr "Sage Intelligent Time requires browser cookies to load."

msgid "Sage Intelligent Time retains data from the <0>time sources</0> you connect to help improve its capabilities to predict how activities are assigned. Reducing the retention period of data for your company's users may impact the quality of these predictions and consequently the accuracy and the time it takes for your employees to complete their timesheets. Employees may choose a period less than this default setting if they choose."
msgstr "Sage Intelligent Time retains data from the <0>time sources</0> you connect to help improve its capabilities to predict how activities are assigned. Reducing the retention period of data for your company's users may impact the quality of these predictions and consequently the accuracy and the time it takes for your employees to complete their timesheets. Employees may choose a period less than this default setting if they choose."

msgid "Sage Intelligent Time retains data from the account(s) you connect to help improve its capabilities to predict how activities are assigned. Reducing the retention period of data may impact the quality of these predictions and consequently the accuracy and the time it takes for you to complete your timesheets. You may change this setting at any time."
msgstr "Sage Intelligent Time retains data from the account(s) you connect to help improve its capabilities to predict how activities are assigned. Reducing the retention period of data may impact the quality of these predictions and consequently the accuracy and the time it takes for you to complete your timesheets. You may change this setting at any time."

msgid "Sage Time Assistant not installed."
msgstr "Sage Time Assistant not installed."

msgid "Saturday"
msgstr "Saturday"

msgid "Save"
msgstr "Save"

msgid "Save changes"
msgstr "Save changes"

msgid "Saved"
msgstr "Saved"

msgid "Saving..."
msgstr "Saving..."

msgid "Scheduled system maintenance"
msgstr "Scheduled system maintenance"

msgid "Search address..."
msgstr "Search address..."

msgid "Search employees"
msgstr "Search employees"

msgid "Search failed. Please try again."
msgstr "Search failed. Please try again."

#. Accessible label for the feature flag search field in developer settings
msgid "Search..."
msgstr "Search..."

msgid "Searching..."
msgstr "Searching..."

msgid "See entry"
msgstr "See entry"

msgid "Select"
msgstr "Select"

msgid "Select {crewMemberLabel}"
msgstr "Select {crewMemberLabel}"

msgid "Select {dimensionTerm}"
msgstr "Select {dimensionTerm}"

msgid "Select {label}"
msgstr "Select {label}"

msgid "Select {title}"
msgstr "Select {title}"

msgid "Select a template to auto-populate the form with predefined values"
msgstr "Select a template to auto-populate the form with predefined values"

msgid "Select a work location and enter a reason before clocking out."
msgstr "Select a work location and enter a reason before clocking out."

msgid "Select a work location before clocking out."
msgstr "Select a work location before clocking out."

msgid "Select all required dimensions for rows with time entries before submitting."
msgstr "Select all required dimensions for rows with time entries before submitting."

msgid "Select allocation"
msgstr "Select allocation"

msgid "Select an employee who is not already in this crew timesheet."
msgstr "Select an employee who is not already in this crew timesheet."

msgid "Select at least one time clock to delete."
msgstr "Select at least one time clock to delete."

msgid "Select cost type"
msgstr "Select cost type"

msgid "Select customer"
msgstr "Select customer"

msgid "Select department"
msgstr "Select department"

msgid "Select employee"
msgstr "Select employee"

msgid "Select employee position"
msgstr "Select employee position"

msgid "Select files"
msgstr "Select files"

msgid "Select item"
msgstr "Select item"

msgid "Select labor class"
msgstr "Select labor class"

msgid "Select labor shift"
msgstr "Select labor shift"

msgid "Select labor union"
msgstr "Select labor union"

msgid "Select leave type"
msgstr "Select leave type"

msgid "Select location"
msgstr "Select location"

msgid "Select project"
msgstr "Select project"

msgid "Select ruleset to reassign"
msgstr "Select ruleset to reassign"

msgid "Select task"
msgstr "Select task"

msgid "Select the date that this timesheet begins. Your company settings determine which day of the week timesheets can start. Admins can change the setting by going to <0>Company</0> > <1>Setup</1> > <2>Company</2> > <3>Accounting</3> and adjusting the <4>Week begins on</4> field."
msgstr "Select the date that this timesheet begins. Your company settings determine which day of the week timesheets can start. Admins can change the setting by going to <0>Company</0> > <1>Setup</1> > <2>Company</2> > <3>Accounting</3> and adjusting the <4>Week begins on</4> field."

msgid "Select the row you would like to merge with."
msgstr "Select the row you would like to merge with."

msgid "Select time type"
msgstr "Select time type"

msgid "Select work location"
msgstr "Select work location"

msgid "Selected (name, start date)"
msgstr "Selected (name, start date)"

msgid "Selected employees ({selectedEmployeesCount})"
msgstr "Selected employees ({selectedEmployeesCount})"

msgid "Selected location"
msgstr "Selected location"

msgid "Set clock out time"
msgstr "Set clock out time"

msgid "Set data retention period for this account"
msgstr "Set data retention period for this account"

msgid "Settings | Sage Intelligent Time"
msgstr "Settings | Sage Intelligent Time"

msgid "Setup Time Assistant"
msgstr "Setup Time Assistant"

msgid "Show overtime"
msgstr "Show overtime"

msgid "Showing {approvalCount} of {approvalTotal} relationships"
msgstr "Showing {approvalCount} of {approvalTotal} relationships"

msgid "Sick (approved)"
msgstr "Sick (approved)"

msgid "Sick (pending)"
msgstr "Sick (pending)"

msgid "Sick accrual"
msgstr "Sick accrual"

msgid "Sick Leave"
msgstr "Sick Leave"

msgid "Sick leave accrual method is required"
msgstr "Sick leave accrual method is required"

msgid "Sick leave accrual rule"
msgstr "Sick leave accrual rule"

msgid "Sick leave balance"
msgstr "Sick leave balance"

msgid "Some crew member timesheets could not be submitted. Review the details and try again."
msgstr "Some crew member timesheets could not be submitted. Review the details and try again."

msgid "Some overtime hours are overapplied. Review the overtime breakdown for details."
msgstr "Some overtime hours are overapplied. Review the overtime breakdown for details."

msgid "Some overtime hours remain unapplied. Review the overtime breakdown for details."
msgstr "Some overtime hours remain unapplied. Review the overtime breakdown for details."

msgid "Some timesheets have errors. Select View error next to an affected employee to review and resolve them."
msgstr "Some timesheets have errors. Select View error next to an affected employee to review and resolve them."

msgid "Some timesheets have overtime issues. Select Resolve overtime next to an affected employee to review and resolve them."
msgstr "Some timesheets have overtime issues. Select Resolve overtime next to an affected employee to review and resolve them."

msgid "Something went wrong"
msgstr "Something went wrong"

msgid "Something went wrong."
msgstr "Something went wrong."

msgid "Something went wrong. Please try again."
msgstr "Something went wrong. Please try again."

msgid "Sorry, this page isn't available."
msgstr "Sorry, this page isn't available."

msgid "Source"
msgstr "Source"

msgid "Split"
msgstr "Split"

msgid "Split time cannot be after clock out time"
msgstr "Split time cannot be after clock out time"

msgid "Split time cannot be before clock in time"
msgstr "Split time cannot be before clock in time"

msgid "Split time cannot be in the future"
msgstr "Split time cannot be in the future"

msgid "Split time clock"
msgstr "Split time clock"

msgid "Splitting..."
msgstr "Splitting..."

msgid "Staff leave"
msgstr "Staff leave"

msgid "Staff leave | Sage Intelligent Time"
msgstr "Staff leave | Sage Intelligent Time"

msgid "Staff time clocks"
msgstr "Staff time clocks"

msgid "Staff time clocks | Sage Intelligent Time"
msgstr "Staff time clocks | Sage Intelligent Time"

msgid "Staff timesheet"
msgstr "Staff timesheet"

msgid "Staff timesheets"
msgstr "Staff timesheets"

msgid "Staff timesheets | Sage Intelligent Time"
msgstr "Staff timesheets | Sage Intelligent Time"

msgid "Start break"
msgstr "Start break"

msgid "Start building your crew timesheet!"
msgstr "Start building your crew timesheet!"

msgid "Start building your timesheet!"
msgstr "Start building your timesheet!"

msgid "Start date"
msgstr "Start date"

msgid "Start date for when this ruleset should apply"
msgstr "Start date for when this ruleset should apply"

msgid "Start date is required"
msgstr "Start date is required"

msgid "State"
msgstr "State"

msgid "Status"
msgstr "Status"

msgid "Status message"
msgstr "Status message"

msgid "submit"
msgstr "submit"

msgid "Submit a new leave request. All fields marked with * are required."
msgstr "Submit a new leave request. All fields marked with * are required."

msgid "Submit a new leave request. Select the employee and fill in the required fields."
msgstr "Submit a new leave request. Select the employee and fill in the required fields."

msgid "Submit adjustment"
msgstr "Submit adjustment"

msgid "Submit anyway"
msgstr "Submit anyway"

msgid "Submit crew timesheet"
msgstr "Submit crew timesheet"

msgid "Submit request"
msgstr "Submit request"

msgid "Submit timesheet"
msgstr "Submit timesheet"

msgid "Submitted"
msgstr "Submitted"

msgid "Submitted to"
msgstr "Submitted to"

msgid "Submitted: {submittedDate}"
msgstr "Submitted: {submittedDate}"

msgid "Submitting crew timesheets, we'll notify you when we finish."
msgstr "Submitting crew timesheets, we'll notify you when we finish."

msgid "Submitting your timesheet, we'll notify you when we finish."
msgstr "Submitting your timesheet, we'll notify you when we finish."

msgid "Successfully approved"
msgstr "Successfully approved"

msgid "Successfully connected your calendar."
msgstr "Successfully connected your calendar."

msgid "Successfully connected your email."
msgstr "Successfully connected your email."

msgid "Successfully declined"
msgstr "Successfully declined"

msgid "Successfully processed"
msgstr "Successfully processed"

msgid "Successfully running the Time Assistant."
msgstr "Successfully running the Time Assistant."

msgid "Sunday"
msgstr "Sunday"

msgid "Switch to top level"
msgstr "Switch to top level"

msgid "Sync another calendar or return to time sources."
msgstr "Sync another calendar or return to time sources."

msgid "Sync another email or return to time sources."
msgstr "Sync another email or return to time sources."

msgid "Sync company"
msgstr "Sync company"

msgid "Sync data from Intacct"
msgstr "Sync data from Intacct"

msgid "Sync draft timesheets"
msgstr "Sync draft timesheets"

msgid "Sync draft timesheets to Intacct"
msgstr "Sync draft timesheets to Intacct"

msgid "Sync draft timesheets to the time repository"
msgstr "Sync draft timesheets to the time repository"

msgid "Sync failed with error:"
msgstr "Sync failed with error:"

msgid "Sync one or more accounts by selecting your cloud provider."
msgstr "Sync one or more accounts by selecting your cloud provider."

msgid "Sync queued"
msgstr "Sync queued"

msgid "Sync started {syncStart}"
msgstr "Sync started {syncStart}"

msgid "Sync your data to get auto-generated timesheets."
msgstr "Sync your data to get auto-generated timesheets."

msgid "Synced successfully {syncEnd}"
msgstr "Synced successfully {syncEnd}"

msgid "Syncing your timesheet, we'll notify you when we finish."
msgstr "Syncing your timesheet, we'll notify you when we finish."

msgid "Task"
msgstr "Task"

msgid "Team leave"
msgstr "Team leave"

msgid "Team leave | Sage Intelligent Time"
msgstr "Team leave | Sage Intelligent Time"

msgid "Tenure (Months)"
msgstr "Tenure (Months)"

msgid "Tenure (Years)"
msgstr "Tenure (Years)"

msgid "Tenure Milestone"
msgstr "Tenure Milestone"

msgid "Tenure Tiered"
msgstr "Tenure Tiered"

msgid "Tenure tiers must use numbers that are 0 or greater"
msgstr "Tenure tiers must use numbers that are 0 or greater"

msgid "The crew timesheet was not opened from the top level."
msgstr "The crew timesheet was not opened from the top level."

msgid "The end date is automatically calculated based on your selected begin date and your company settings. Admins can change the setting by going to <0>Projects</0> > <1>Setup</1> > <2>Projects configuration</2> and adjusting the <3>Timesheet duration</3> field. The duration can be daily, weekly, every two weeks, or twice per month."
msgstr "The end date is automatically calculated based on your selected begin date and your company settings. Admins can change the setting by going to <0>Projects</0> > <1>Setup</1> > <2>Projects configuration</2> and adjusting the <3>Timesheet duration</3> field. The duration can be daily, weekly, every two weeks, or twice per month."

#. placeholder {0}: data?.length ?? 0
msgid "The following {0, plural, one {time clock} other {time clocks}} will be permanently deleted."
msgstr "The following {0, plural, one {time clock} other {time clocks}} will be permanently deleted."

msgid "The following {breakCount, plural, one {break} other {breaks}} will be permanently deleted."
msgstr "The following {breakCount, plural, one {break} other {breaks}} will be permanently deleted."

msgid "The following overtime discrepancies were detected. You can {actionVerb} anyway, but you may want to review and apply overtime first."
msgstr "The following overtime discrepancies were detected. You can {actionVerb} anyway, but you may want to review and apply overtime first."

msgid "The link you followed may be broken, or the page may have been removed."
msgstr "The link you followed may be broken, or the page may have been removed."

msgid "The maximum file size is {size}."
msgstr "The maximum file size is {size}."

msgid "The option “<0>See and download any calendar you can access using your Google Calendar</0>” needs to be selected in order to connect your calendar."
msgstr "The option “<0>See and download any calendar you can access using your Google Calendar</0>” needs to be selected in order to connect your calendar."

msgid "The standalone version of Sage Intelligent Time was officially retired on <0>September 30, 2025</0>."
msgstr "The standalone version of Sage Intelligent Time was officially retired on <0>September 30, 2025</0>."

msgid "The timesheet was not opened from the top level."
msgstr "The timesheet was not opened from the top level."

msgid "There are no leave policies configured."
msgstr "There are no leave policies configured."

msgid "There are no overtime rulesets."
msgstr "There are no overtime rulesets."

msgid "There are no time entries to review at the moment."
msgstr "There are no time entries to review at the moment."

msgid "There are no timesheets to review at the moment."
msgstr "There are no timesheets to review at the moment."

msgid "This action cannot be completed because the time clock includes a holiday. Adjust the time range, then try again."
msgstr "This action cannot be completed because the time clock includes a holiday. Adjust the time range, then try again."

msgid "This action cannot be undone."
msgstr "This action cannot be undone."

msgid "This action is only available when running inside Intacct."
msgstr "This action is only available when running inside Intacct."

msgid "This calendar is connected."
msgstr "This calendar is connected."

msgid "This calendar is not connected."
msgstr "This calendar is not connected."

msgid "This cannot be undone."
msgstr "This cannot be undone."

msgid "This crew timesheet is read-only"
msgstr "This crew timesheet is read-only"

msgid "This field is required"
msgstr "This field is required"

msgid "This map shows where the employee clocked in."
msgstr "This map shows where the employee clocked in."

msgid "This page is intended for internal/demo use only!"
msgstr "This page is intended for internal/demo use only!"

msgid "This ruleset was created from a predefined template"
msgstr "This ruleset was created from a predefined template"

msgid "This template is deprecated on {predefinedRulesetDeprecatedAt} and may not be suitable for use"
msgstr "This template is deprecated on {predefinedRulesetDeprecatedAt} and may not be suitable for use"

msgid "This time clock action is already in progress. Please wait for it to finish."
msgstr "This time clock action is already in progress. Please wait for it to finish."

msgid "This time clock cannot be changed because today is {holidayName}, and your company does not allow working on holidays. Ask a staff user to adjust the time clock."
msgstr "This time clock cannot be changed because today is {holidayName}, and your company does not allow working on holidays. Ask a staff user to adjust the time clock."

msgid "This time clock has a location violation."
msgstr "This time clock has a location violation."

msgid "This time clock is already being saved. Please wait for it to finish."
msgstr "This time clock is already being saved. Please wait for it to finish."

msgid "This time clock is already being split. Please wait for it to finish."
msgstr "This time clock is already being split. Please wait for it to finish."

msgid "This timesheet has errors that must be fixed."
msgstr "This timesheet has errors that must be fixed."

msgid "This timesheet is read-only"
msgstr "This timesheet is read-only"

msgid "This will automatically distribute overtime to balance hours."
msgstr "This will automatically distribute overtime to balance hours."

msgid "This will delete all data associated with this time source."
msgstr "This will delete all data associated with this time source."

msgid "Threshold (days)"
msgstr "Threshold (days)"

msgid "Threshold (hours)"
msgstr "Threshold (hours)"

msgid "threshold must be between 0 and {maxThreshold}"
msgstr "threshold must be between 0 and {maxThreshold}"

msgid "Thursday"
msgstr "Thursday"

msgid "Time approval | Sage Intelligent Time"
msgstr "Time approval | Sage Intelligent Time"

msgid "Time approvals | Sage Intelligent Time"
msgstr "Time approvals | Sage Intelligent Time"

msgid "Time Assistant"
msgstr "Time Assistant"

msgid "Time Assistant logo"
msgstr "Time Assistant logo"

msgid "Time Assistant, you may still use Sage Intelligent Time to create timesheets. Should you choose to download and install Time Assistant, you can withdraw your consent to its operation, updates and upgrades at any time by uninstalling the app as described for your operating system here:"
msgstr "Time Assistant, you may still use Sage Intelligent Time to create timesheets. Should you choose to download and install Time Assistant, you can withdraw your consent to its operation, updates and upgrades at any time by uninstalling the app as described for your operating system here:"

#. Accessible name for the tabs in the employee time clock form
msgid "Time clock"
msgstr "Time clock"

msgid "Time clock date"
msgstr "Time clock date"

msgid "Time clock ID not found"
msgstr "Time clock ID not found"

msgid "Time clock not found"
msgstr "Time clock not found"

msgid "Time clock updated"
msgstr "Time clock updated"

msgid "Time clocks | Sage Intelligent Time"
msgstr "Time clocks | Sage Intelligent Time"

msgid "Time entries table"
msgstr "Time entries table"

msgid "Time entry date"
msgstr "Time entry date"

msgid "Time entry details"
msgstr "Time entry details"

msgid "Time gathering"
msgstr "Time gathering"

msgid "Time increment step"
msgstr "Time increment step"

msgid "Time preferences"
msgstr "Time preferences"

msgid "Time Preferences"
msgstr "Time Preferences"

msgid "Time preferences | Sage Intelligent Time"
msgstr "Time preferences | Sage Intelligent Time"

msgid "Time source"
msgstr "Time source"

msgid "Time sources"
msgstr "Time sources"

msgid "Time Sources | Sage Intelligent Time"
msgstr "Time Sources | Sage Intelligent Time"

msgid "Time tracking"
msgstr "Time tracking"

msgid "Time Tracking"
msgstr "Time Tracking"

msgid "Time type"
msgstr "Time type"

msgid "Time type used to apply rules in this group"
msgstr "Time type used to apply rules in this group"

msgid "Time type used to apply the rule in the timesheet"
msgstr "Time type used to apply the rule in the timesheet"

msgid "Timesheet | Sage Intelligent Time"
msgstr "Timesheet | Sage Intelligent Time"

msgid "Timesheet begin date"
msgstr "Timesheet begin date"

msgid "Timesheet dimensions order"
msgstr "Timesheet dimensions order"

msgid "Timesheet header errors"
msgstr "Timesheet header errors"

msgid "Timesheet period"
msgstr "Timesheet period"

msgid "Timesheet recalled"
msgstr "Timesheet recalled"

msgid "Timesheet reminders"
msgstr "Timesheet reminders"

msgid "Timesheet status"
msgstr "Timesheet status"

msgid "Timesheet submission succeeded"
msgstr "Timesheet submission succeeded"

msgid "Timesheets | Sage Intelligent Time"
msgstr "Timesheets | Sage Intelligent Time"

msgid "Timezone"
msgstr "Timezone"

msgid "to create a new timesheet row"
msgstr "to create a new timesheet row"

msgid "To do"
msgstr "To do"

msgid "To edit the crew timesheet, switch to the top level using the entity picker above."
msgstr "To edit the crew timesheet, switch to the top level using the entity picker above."

msgid "To edit the timesheet, switch to the top level using the entity picker above."
msgstr "To edit the timesheet, switch to the top level using the entity picker above."

msgid "To ensure uninterrupted access, please transition to the embedded experience within <0>Sage Intacct</0> by <1>October 10, 2025</1>. Going forward, Sage Intelligent Time must be accessed directly from within <2>Sage Intacct</2>."
msgstr "To ensure uninterrupted access, please transition to the embedded experience within <0>Sage Intacct</0> by <1>October 10, 2025</1>. Going forward, Sage Intelligent Time must be accessed directly from within <2>Sage Intacct</2>."

msgid "To list <0>My timesheets</0>, your user ID must be associated with an employee record and have permission. Contact your admin to update your record."
msgstr "To list <0>My timesheets</0>, your user ID must be associated with an employee record and have permission. Contact your admin to update your record."

msgid "to mark it as unassigned"
msgstr "to mark it as unassigned"

msgid "To move the activity to a different project instead of merging, click back and edit the assignment details."
msgstr "To move the activity to a different project instead of merging, click back and edit the assignment details."

msgid "To view <0>My timesheets</0>, your user ID must be associated with an employee record and have permission. Contact your admin to update your record."
msgstr "To view <0>My timesheets</0>, your user ID must be associated with an employee record and have permission. Contact your admin to update your record."

msgid "Today"
msgstr "Today"

msgid "Top level"
msgstr "Top level"

msgid "Total"
msgstr "Total"

msgid "Total hours"
msgstr "Total hours"

msgid "Total time"
msgstr "Total time"

msgid "Totals"
msgstr "Totals"

msgid "Tuesday"
msgstr "Tuesday"

msgid "Turn on notifications"
msgstr "Turn on notifications"

msgid "twice per month"
msgstr "twice per month"

msgid "Type"
msgstr "Type"

msgid "Type to search"
msgstr "Type to search"

msgid "UI"
msgstr "UI"

msgid "Unable to load the page."
msgstr "Unable to load the page."

msgid "Unable to save changes to the attachments"
msgstr "Unable to save changes to the attachments"

msgid "Unassign"
msgstr "Unassign"

msgid "Unassign ruleset"
msgstr "Unassign ruleset"

msgid "Unassigned"
msgstr "Unassigned"

msgid "Unassigning..."
msgstr "Unassigning..."

msgid "Unauthorized"
msgstr "Unauthorized"

msgid "Unavailable"
msgstr "Unavailable"

msgid "Units"
msgstr "Units"

msgid "Unknown"
msgstr "Unknown"

msgid "Unknown activity type"
msgstr "Unknown activity type"

msgid "Unknown template"
msgstr "Unknown template"

msgid "Unlimited"
msgstr "Unlimited"

msgid "Unsaved changes"
msgstr "Unsaved changes"

msgid "Unsupported OS"
msgstr "Unsupported OS"

msgid "Up"
msgstr "Up"

msgid "Update request details"
msgstr "Update request details"

msgid "Updated"
msgstr "Updated"

msgid "Updating..."
msgstr "Updating..."

msgid "Use your calendar email and computer activity to easily create accurate timesheet entries"
msgstr "Use your calendar email and computer activity to easily create accurate timesheet entries"

msgid "Used for: To help you create timesheet entries and to train algorithms that automate creation of timesheet entry descriptions."
msgstr "Used for: To help you create timesheet entries and to train algorithms that automate creation of timesheet entry descriptions."

msgid "Used since:"
msgstr "Used since:"

msgid "User not found"
msgstr "User not found"

msgid "Value must be 0 or greater"
msgstr "Value must be 0 or greater"

msgid "Value must be greater than 0"
msgstr "Value must be greater than 0"

msgid "Variance"
msgstr "Variance"

msgid "Vendor"
msgstr "Vendor"

msgid "View all breaks"
msgstr "View all breaks"

msgid "View audit trail"
msgstr "View audit trail"

msgid "View balance adjustments"
msgstr "View balance adjustments"

msgid "View details"
msgstr "View details"

msgid "View error"
msgstr "View error"

msgid "View rate card"
msgstr "View rate card"

msgid "View time clock"
msgstr "View time clock"

msgid "View timesheet"
msgstr "View timesheet"

msgid "Violation reason"
msgstr "Violation reason"

msgid "Web notification"
msgstr "Web notification"

msgid "Wednesday"
msgstr "Wednesday"

msgid "Weekend"
msgstr "Weekend"

msgid "Weekend days (excluded):"
msgstr "Weekend days (excluded):"

msgid "Weekends:"
msgstr "Weekends:"

msgid "Weekly"
msgstr "Weekly"

msgid "Weekly overtime information – {weekStart} to {weekEnd}"
msgstr "Weekly overtime information – {weekStart} to {weekEnd}"

msgid "When a calendar account isn’t connected properly"
msgstr "When a calendar account isn’t connected properly"

msgid "When an email account isn’t connected properly"
msgstr "When an email account isn’t connected properly"

msgid "When assigning an activity card, by default decide if you want to have it be merged with an existing timesheet row, or added to a new timesheet row."
msgstr "When assigning an activity card, by default decide if you want to have it be merged with an existing timesheet row, or added to a new timesheet row."

msgid "When haven’t entered any time by"
msgstr "When haven’t entered any time by"

msgid "When I haven’t created a timesheet"
msgstr "When I haven’t created a timesheet"

msgid "When I haven’t submitted a timesheet"
msgstr "When I haven’t submitted a timesheet"

msgid "When the Time Assistant isn’t connected properly"
msgstr "When the Time Assistant isn’t connected properly"

msgid "When to apply accrual"
msgstr "When to apply accrual"

msgid "With our mobile app, you can do the following:"
msgstr "With our mobile app, you can do the following:"

msgid "Work location"
msgstr "Work location"

msgid "Work locations"
msgstr "Work locations"

msgid "Work locations are still loading. Please wait, then try again."
msgstr "Work locations are still loading. Please wait, then try again."

msgid "Work locations are still loading. Please wait, then try to clock in again."
msgstr "Work locations are still loading. Please wait, then try to clock in again."

msgid "Work locations are still loading. Please wait, then try to reuse this time clock again."
msgstr "Work locations are still loading. Please wait, then try to reuse this time clock again."

msgid "Work time"
msgstr "Work time"

msgid "Write your own formula using available variables"
msgstr "Write your own formula using available variables"

msgid "Yearly"
msgstr "Yearly"

msgid "Years of service"
msgstr "Years of service"

msgid "Years until bonus"
msgstr "Years until bonus"

msgid "Years with the company"
msgstr "Years with the company"

msgid "Yes"
msgstr "Yes"

msgid "You cannot change this time clock because today is <0>{holidayName}</0>, and your company does not allow working on holidays. Ask a staff user to adjust your time clock."
msgstr "You cannot change this time clock because today is <0>{holidayName}</0>, and your company does not allow working on holidays. Ask a staff user to adjust your time clock."

msgid "You cannot clock in because today is {holidayName}, and your company does not allow working on holidays."
msgstr "You cannot clock in because today is {holidayName}, and your company does not allow working on holidays."

msgid "You cannot clock in because today is <0>{holidayName}</0>, and your company does not allow working on holidays."
msgstr "You cannot clock in because today is <0>{holidayName}</0>, and your company does not allow working on holidays."

msgid "You cannot delete this row"
msgstr "You cannot delete this row"

msgid "You cannot reuse this time clock because today is {holidayName}, and your company does not allow working on holidays."
msgstr "You cannot reuse this time clock because today is {holidayName}, and your company does not allow working on holidays."

msgid "You do not have permission to view or edit attachments."
msgstr "You do not have permission to view or edit attachments."

msgid "You do not have permissions to edit timesheets in Intacct."
msgstr "You do not have permissions to edit timesheets in Intacct."

msgid "You have connected your calendar but we don't have any events from you recently. Please contact support."
msgstr "You have connected your calendar but we don't have any events from you recently. Please contact support."

msgid "You must also uninstall Time Assistant from your desktop computer as described in the <0>documentation</0>."
msgstr "You must also uninstall Time Assistant from your desktop computer as described in the <0>documentation</0>."

msgid "You must have an employee record in Intacct to create a timesheet."
msgstr "You must have an employee record in Intacct to create a timesheet."

msgid "You must have at least one valid overtime rule or rule group to create a ruleset."
msgstr "You must have at least one valid overtime rule or rule group to create a ruleset."

msgid "You must have permissions to create staff timesheets in Intacct."
msgstr "You must have permissions to create staff timesheets in Intacct."

msgid "You must have permissions to edit staff timesheets in Intacct."
msgstr "You must have permissions to edit staff timesheets in Intacct."

msgid "You must select a crew to create a crew timesheet."
msgstr "You must select a crew to create a crew timesheet."

msgid "You recently connected your calendar. Please wait for up to 24 hours for the initial connection to complete."
msgstr "You recently connected your calendar. Please wait for up to 24 hours for the initial connection to complete."

msgid "You recently connected your email. Please wait for up to 24 hours for the initial connection to complete."
msgstr "You recently connected your email. Please wait for up to 24 hours for the initial connection to complete."

msgid "You unsuccessfully attempted to connect your calendar. Please try again."
msgstr "You unsuccessfully attempted to connect your calendar. Please try again."

msgid "You unsuccessfully attempted to connect your email."
msgstr "You unsuccessfully attempted to connect your email."

msgid "You've downloaded the Time Assistant but you either haven't logged in to the app or you haven't run the installer yet."
msgstr "You've downloaded the Time Assistant but you either haven't logged in to the app or you haven't run the installer yet."

msgid "Your cards for calendar, computer, and email activity will appear here once they’ve been assigned."
msgstr "Your cards for calendar, computer, and email activity will appear here once they’ve been assigned."

msgid "Your cards for calendar, computer, and email activity will appear here."
msgstr "Your cards for calendar, computer, and email activity will appear here."

msgid "Your company's Web Services User (WSU) is not set up to view or edit attachments. Please have your company's administrator contact support to use attachments."
msgstr "Your company's Web Services User (WSU) is not set up to view or edit attachments. Please have your company's administrator contact support to use attachments."

msgid "Your Time Assistant is either paused or not running right now. Please allow 3 hours after installation to connect."
msgstr "Your Time Assistant is either paused or not running right now. Please allow 3 hours after installation to connect."

msgid "Your Time Assistant is setup, click below to launch it."
msgstr "Your Time Assistant is setup, click below to launch it."

msgid "Your Time Assistant preferences are not configured correctly."
msgstr "Your Time Assistant preferences are not configured correctly."

msgid "Your timesheet failed to submit"
msgstr "Your timesheet failed to submit"

msgid "Your timesheet has been successfully submitted"
msgstr "Your timesheet has been successfully submitted"

msgid "Your timesheet has been successfully synced to Intacct"
msgstr "Your timesheet has been successfully synced to Intacct"

msgid "Your timesheet has failed to sync to Intacct"
msgstr "Your timesheet has failed to sync to Intacct"

msgid "Zero state"
msgstr "Zero state"
